require("./index.css");
var $gXNCa$reduxbundler = require("redux-bundler");
var $gXNCa$lodash = require("lodash");
var $gXNCa$gramenebinsclient = require("gramene-bins-client");
var $gXNCa$gramenetreesclient = require("gramene-trees-client");
var $gXNCa$gramenetaxonomywithgenomes = require("gramene-taxonomy-with-genomes");
var $gXNCa$reactga4 = require("react-ga4");
var $gXNCa$reactjsxruntime = require("react/jsx-runtime");
var $gXNCa$reduxbundlerreact = require("redux-bundler-react");
var $gXNCa$react = require("react");
var $gXNCa$reactbootstrap = require("react-bootstrap");
var $gXNCa$reactswitch = require("react-switch");
var $gXNCa$reacticonsio5 = require("react-icons/io5");
var $gXNCa$reacticonsbs = require("react-icons/bs");
var $gXNCa$reacticonsgr = require("react-icons/gr");
var $gXNCa$grameneefpbrowser = require("gramene-efp-browser");
var $gXNCa$gramenegenetreevis = require("gramene-genetree-vis");
var $gXNCa$lodashkeyBy = require("lodash/keyBy");
var $gXNCa$reacticonsbi = require("react-icons/bi");
var $gXNCa$firebaseapp = require("firebase/app");
var $gXNCa$lodashget = require("lodash/get");
var $gXNCa$lodashisEqual = require("lodash/isEqual");
var $gXNCa$flattonested = require("flat-to-nested");
var $gXNCa$reactsimpletreemenu = require("react-simple-tree-menu");
var $gXNCa$aggridreact = require("ag-grid-react");
require("ag-grid-community/styles/ag-grid.css");
require("ag-grid-community/styles/ag-theme-quartz.css");
require("@fortawesome/fontawesome-free/css/all.min.css");
var $gXNCa$gramenedbxrefs = require("gramene-dbxrefs");
var $gXNCa$reacticonsai = require("react-icons/ai");
var $gXNCa$gramenesearchvis = require("gramene-search-vis");
var $gXNCa$numeral = require("numeral");
var $gXNCa$firebaseauth = require("firebase/auth");


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7a41"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7a41"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7u0Mi", function(module, exports) {
module.exports = Promise.resolve(require("./Study.5ff9518c.js")).then(()=>parcelRequire("7zuJ6"));

});


$parcel$export(module.exports, "bundles", () => $5df6c55c1bef3469$export$2e2bcd8739ae039);
$parcel$export(module.exports, "resultList", () => $2fec4872fbf7ebd2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "resultSummary", () => $27617dbc24e7faf0$export$2e2bcd8739ae039);
$parcel$export(module.exports, "suggestions", () => $541b8b0d8c5501d2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Status", () => $693dd8c7a5607c3a$export$96e9906d6d93a972);
$parcel$export(module.exports, "Filters", () => $693dd8c7a5607c3a$export$92a576f896a9bf72);
$parcel$export(module.exports, "Results", () => $693dd8c7a5607c3a$export$4a34de49b46a2bfa);
$parcel$export(module.exports, "Views", () => $693dd8c7a5607c3a$export$5cb791131c501f6a);





const $9d9aeaf9299e61a1$var$facets = [
    "{!facet.limit='200' facet.mincount='1' key='taxon_id'}taxon_id",
    "{!facet.limit='100' facet.mincount='1' key='genetree'}gene_tree",
    "{!facet.limit='100' facet.mincount='1' key='pathways'}pathways__ancestors",
    "{!facet.limit='100' facet.mincount='1' key='domains'}domain_roots",
    "{!facet.limit='-1' facet.mincount='1' key='fixed_1000__bin'}fixed_1000__bin"
];
const $9d9aeaf9299e61a1$var$genomesOfInterest = "(taxon_id:2769) OR (taxon_id:3055) OR (taxon_id:3218) OR (taxon_id:3702) OR (taxon_id:3847) OR (taxon_id:4555) OR (taxon_id:4558) OR (taxon_id:4577) OR (taxon_id:13333) OR (taxon_id:15368) OR (taxon_id:29760) OR (taxon_id:39947) OR (taxon_id:55577) OR (taxon_id:88036) OR (taxon_id:214687)";
const $9d9aeaf9299e61a1$var$sites = [
    "main",
    "oryza",
    "maize",
    "sorghum",
    "grapevine"
];
const $9d9aeaf9299e61a1$var$grameneSuggestions = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: "grameneSuggestions",
    actionBaseType: "GRAMENE_SUGGESTIONS",
    persist: false,
    getPromise: ({ store: store })=>{
        const t = store.selectSuggestionsQuery().replaceAll(":", " ").trim();
        const g = store.selectGrameneGenomes();
        const q = `/suggest?q={!boost b=relevance}name:${t}^5 ids:${t}^5 ids:${t}*^3 synonym:${t}^3 synonym:${t}*^2 text:${t}*^1`;
        // const promises = sites.map(site => fetch(`https://data.gramene.org/${site}${q}`));
        // return Promise.all(promises)
        return fetch(store.selectGrameneAPI() + q).then((res)=>{
            return res.json();
        }).then((suggestions)=>{
            if (Object.keys(g.active).length > 0) suggestions.grouped.category.groups.forEach((group)=>{
                group.doclist.docs.forEach((sugg)=>{
                    sugg.num_genes = 0;
                    sugg.taxon_id.forEach((id, idx)=>{
                        if (g.active[id] && !g.active[id].hidden) sugg.num_genes += sugg.taxon_freq[idx];
                    });
                });
            });
            return suggestions;
        });
    }
});
$9d9aeaf9299e61a1$var$grameneSuggestions.reactGrameneSuggestions = (0, $gXNCa$reduxbundler.createSelector)("selectGrameneSuggestionsShouldUpdate", "selectSuggestionsQuery", (shouldUpdate, queryString)=>{
    if (shouldUpdate && queryString) return {
        actionCreator: "doFetchGrameneSuggestions"
    };
});
$9d9aeaf9299e61a1$var$grameneSuggestions.selectGrameneSuggestionsStatus = (0, $gXNCa$reduxbundler.createSelector)("selectGrameneSuggestionsShouldUpdate", "selectGrameneSuggestionsIsLoading", "selectGrameneSuggestionsRaw", "selectSuggestionsQuery", (shouldUpdate, isLoading, suggestionsRaw, queryString)=>{
    if (!queryString) return "";
    if (shouldUpdate) return "update needed";
    if (isLoading) return "loading";
    if (suggestionsRaw) return suggestionsRaw.data.grouped.category.matches + " terms";
    return "error";
});
$9d9aeaf9299e61a1$var$grameneSuggestions.selectGrameneSuggestionsReady = (0, $gXNCa$reduxbundler.createSelector)("selectGrameneSuggestionsStatus", (status)=>{
    const regex = RegExp("terms$");
    return regex.test(status);
});
$9d9aeaf9299e61a1$var$grameneSuggestions.doFocusFirstGrameneSuggestion = (arg)=>({ dispatch: dispatch, getState: getState })=>{
        console.log("inside doFocusFirstGrameneSuggestion");
    };
function $9d9aeaf9299e61a1$var$compressLongTaxonName(node) {
    const fullName = node.name;
    const removedExtraineousWords = fullName.replace(/( Group$| subsp\.| ssp\.| var\.| strain)/, "");
    let finalVersion;
    if (removedExtraineousWords.length > 20) {
        let words = removedExtraineousWords.split(" ");
        if (words.length === 2) // abrreviate first word.
        finalVersion = removedExtraineousWords.replace(/^([A-Z])[a-z]+/, "$1.");
        if (words.length > 2) finalVersion = removedExtraineousWords.replace(/^([A-Z])[a-z]+\s([a-z])[a-z]+/, "$1$2.");
    } else finalVersion = removedExtraineousWords;
    node.short_name = finalVersion;
}
const $9d9aeaf9299e61a1$var$grameneTaxonomy = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: "grameneTaxonomy",
    actionBaseType: "GRAMENE_TAXONOMY",
    persist: true,
    getPromise: ({ store: store })=>{
        return fetch(`${store.selectGrameneAPI()}/taxonomy?subset=gramene&rows=-1`).then((res)=>res.json()).then((taxNodes)=>{
            let taxonomy = (0, ($parcel$interopDefault($gXNCa$lodash))).keyBy(taxNodes, "_id");
            taxNodes.forEach((t)=>{
                t._id = +t._id; // ensure taxonomy id is a number
                $9d9aeaf9299e61a1$var$compressLongTaxonName(t);
                if (t.hasOwnProperty("is_a")) t.is_a.forEach((p_id)=>{
                    const p = taxonomy[p_id];
                    if (!p.hasOwnProperty("children")) p.children = [];
                    p.children.push(t._id);
                });
            });
            return taxonomy;
        });
    }
});
$9d9aeaf9299e61a1$var$grameneTaxonomy.reactGrameneTaxonomy = (0, $gXNCa$reduxbundler.createSelector)("selectGrameneTaxonomyShouldUpdate", (shouldUpdate)=>{
    if (shouldUpdate) return {
        actionCreator: "doFetchGrameneTaxonomy"
    };
});
const $9d9aeaf9299e61a1$var$grameneMaps = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: "grameneMaps",
    actionBaseType: "GRAMENE_MAPS",
    persist: true,
    getPromise: ({ store: store })=>{
        return fetch(`${store.selectGrameneAPI()}/maps?rows=-1`).then((res)=>res.json()).then((maps)=>{
            maps.forEach((m)=>{
                m.regionLength = {};
                m.regions.names.forEach((rname, idx)=>{
                    m.regionLength[rname] = m.regions.lengths[idx];
                });
            });
            return (0, ($parcel$interopDefault($gXNCa$lodash))).keyBy(maps, "taxon_id");
        });
    }
});
$9d9aeaf9299e61a1$var$grameneMaps.reactGrameneMaps = (0, $gXNCa$reduxbundler.createSelector)("selectGrameneMapsShouldUpdate", (shouldUpdate)=>{
    if (shouldUpdate) return {
        actionCreator: "doFetchGrameneMaps"
    };
});
const $9d9aeaf9299e61a1$var$expressionStudies = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: "expressionStudies",
    actionBaseType: "EXPRESSION_STUDIES",
    persist: true,
    getPromise: ({ store: store })=>{
        return fetch(`${store.selectGrameneAPI()}/experiments?rows=-1`).then((res)=>res.json()).then((res)=>(0, ($parcel$interopDefault($gXNCa$lodash))).groupBy(res, "taxon_id"));
    }
});
$9d9aeaf9299e61a1$var$expressionStudies.reactExpressionStudies = (0, $gXNCa$reduxbundler.createSelector)("selectExpressionStudiesShouldUpdate", (shouldUpdate)=>{
    if (shouldUpdate) return {
        actionCreator: "doFetchExpressionStudies"
    };
});
const $9d9aeaf9299e61a1$var$expressionSamples = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: "expressionSamples",
    actionBaseType: "EXPRESSION_SAMPLES",
    persist: true,
    getPromise: ({ store: store })=>{
        return fetch(`${store.selectGrameneAPI()}/assays?rows=-1`).then((res)=>res.json()).then((samples)=>(0, ($parcel$interopDefault($gXNCa$lodash))).groupBy(samples, "experiment")).then((studies)=>{
            Object.keys(studies).forEach((study)=>{
                studies[study].forEach((sample)=>{
                    sample.order = +sample.group.replace("g", "");
                });
                studies[study].sort((a, b)=>a.order - b.order);
            });
            return studies;
        });
    }
});
$9d9aeaf9299e61a1$var$expressionSamples.reactExpressionSamples = (0, $gXNCa$reduxbundler.createSelector)("selectExpressionSamplesShouldUpdate", (shouldUpdate)=>{
    if (shouldUpdate) return {
        actionCreator: "doFetchExpressionSamples"
    };
});
const $9d9aeaf9299e61a1$var$curatedGenes = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: "curatedGenes",
    actionBaseType: "CURATED_GENES",
    persist: true,
    getPromise: ({ store: store })=>{
        return fetch(`https://devdata.gramene.org/curation/curations?rows=0&minFlagged=0&since=12-12-2029`).then((res)=>res.json()).then((curation)=>(0, ($parcel$interopDefault($gXNCa$lodash))).keyBy(curation.genes, "gene_id"));
    }
});
$9d9aeaf9299e61a1$var$curatedGenes.reactCuratedGenes = (0, $gXNCa$reduxbundler.createSelector)("selectCuratedGenesShouldUpdate", (shouldUpdate)=>{
    if (shouldUpdate) return {
        actionCreator: "doFetchCuratedGenes"
    };
});
const $9d9aeaf9299e61a1$var$grameneGermplasm = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: "grameneGermplasm",
    actionBaseType: "GRAMENE_GERMPLASM",
    persist: true,
    getPromise: ({ store: store })=>{
        return fetch(`${store.selectGrameneAPI()}/germplasm?rows=-1`).then((res)=>res.json()).then((res)=>(0, ($parcel$interopDefault($gXNCa$lodash))).groupBy(res, "ens_id"));
    }
});
$9d9aeaf9299e61a1$var$grameneGermplasm.reactGrameneGermplasm = (0, $gXNCa$reduxbundler.createSelector)("selectGrameneGermplasmShouldUpdate", (shouldUpdate)=>{
    if (shouldUpdate) return {
        actionCreator: "doFetchGrameneGermplasm"
    };
});
//
// const grameneExpressionAssays = createAsyncResourceBundle( {
//   name: 'grameneExpressionAssays',
//   actionBaseType: 'GRAMENE_EXPRESSION_ASSAYS',
//   persist: true,
//   getPromise: ({store}) => {
//     return fetch(`${store.selectGrameneAPI()}/assays?rows=-1`)
//       .then(res => res.json())
//       .then(res => {
//         let expr={};
//         res.forEach(assay => {
//           if (!expr.hasOwnProperty(assay.taxon_id)) {
//             expr[assay.taxon_id] = {};
//           }
//           if (!expr[assay.taxon_id].hasOwnProperty(assay.experiment)) {
//             expr[assay.taxon_id][assay.experiment] = [];
//           }
//           assay.order = +assay.group.replace('g','');
//           expr[assay.taxon_id][assay.experiment].push(assay);
//         });
//         // sort each experiment
//         for (const tid in expr) {
//           for (const exp in expr[tid]) {
//             expr[tid][exp].sort((a,b) => a.order - b.order);
//           }
//         }
//         return expr;
//       })
//   }
// });
// grameneExpressionAssays.reactGrameneExpressionAssays = createSelector(
//   'selectGrameneExpressionAssaysShouldUpdate',
//   (shouldUpdate) => {
//     if (shouldUpdate) {
//       return { actionCreator: 'doFetchGrameneExpressionAssays' }
//     }
//   }
// );
const $9d9aeaf9299e61a1$var$attribFacetFields = [
    "{!facet.limit='10' facet.mincount='1' key='age'}panset_age_attr_s",
    "{!facet.limit='100' facet.mincount='1' key='taxa'}panset_ntaxa_attr_i",
    "{!facet.limit='100' facet.mincount='1' key='AED' type='range' start=0 end=1.0 gap=0.25}MAKER_AED_attr_f",
    "{!facet.limit='100' facet.mincount='1' key='QI2' type='range' start=0 end=1.0 gap=0.25}MAKER_QI2_attr_f",
    "{!facet.limit='100' facet.mincount='1' key='QI3' type='range' start=0 end=1.0 gap=0.25}MAKER_QI3_attr_f",
    "{!facet.limit='100' facet.mincount='1' key='QI4' type='range' start=0 end=1.0 gap=0.25}MAKER_QI4_attr_f",
    "{!facet.limit='100' facet.mincount='1' key='QI5' type='range' start=0 end=1.0 gap=0.25}MAKER_QI5_attr_f",
    "{!facet.limit='100' facet.mincount='1' key='QI6' type='range' start=0 end=1.0 gap=0.25}MAKER_QI6_attr_f"
];
const $9d9aeaf9299e61a1$var$attribFacets = {
    "age": {
        "type": "terms",
        "field": "panset_age_attr_s"
    },
    "nTaxa": {
        "type": "terms",
        "field": "panset_ntaxa_attr_i",
        "limit": 100
    },
    "AED": {
        "type": "range",
        "field": "MAKER_AED_attr_f",
        "start": 0.0,
        "end": 1.0,
        "gap": 0.25
    },
    "QI2": {
        "type": "range",
        "field": "MAKER_QI2_attr_f",
        "start": 0.0,
        "end": 1.0,
        "gap": 0.25
    },
    "QI3": {
        "type": "range",
        "field": "MAKER_QI3_attr_f",
        "start": 0.0,
        "end": 1.0,
        "gap": 0.25
    },
    "QI4": {
        "type": "range",
        "field": "MAKER_QI4_attr_f",
        "start": 0.0,
        "end": 1.0,
        "gap": 0.25
    },
    "QI5": {
        "type": "range",
        "field": "MAKER_QI5_attr_f",
        "start": 0.0,
        "end": 1.0,
        "gap": 0.25
    },
    "QI6": {
        "type": "range",
        "field": "MAKER_QI6_attr_f",
        "start": 0.0,
        "end": 1.0,
        "gap": 0.25
    },
    "byAge": {
        "type": "terms",
        "field": "panset_age_attr_s",
        "facet": {
            "nTaxa": {
                "type": "terms",
                "field": "panset_ntaxa_attr_i",
                "limit": 100
            },
            "AED": {
                "type": "range",
                "field": "MAKER_AED_attr_f",
                "start": 0.0,
                "end": 1.0,
                "gap": 0.25
            },
            "QI2": {
                "type": "range",
                "field": "MAKER_QI2_attr_f",
                "start": 0.0,
                "end": 1.0,
                "gap": 0.25
            },
            "QI3": {
                "type": "range",
                "field": "MAKER_QI3_attr_f",
                "start": 0.0,
                "end": 1.0,
                "gap": 0.25
            },
            "QI4": {
                "type": "range",
                "field": "MAKER_QI4_attr_f",
                "start": 0.0,
                "end": 1.0,
                "gap": 0.25
            },
            "QI5": {
                "type": "range",
                "field": "MAKER_QI5_attr_f",
                "start": 0.0,
                "end": 1.0,
                "gap": 0.25
            },
            "QI6": {
                "type": "range",
                "field": "MAKER_QI6_attr_f",
                "start": 0.0,
                "end": 1.0,
                "gap": 0.25
            }
        }
    }
};
const $9d9aeaf9299e61a1$var$grameneGeneAttribs = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: "grameneGeneAttribs",
    actionBaseType: "GRAMENE_GENE_ATTRIBS",
    persist: false,
    getPromise: ({ store: store })=>{
        const g = store.selectGrameneGenomes();
        const taxa = Object.keys(g.active);
        let fq = "";
        if (taxa.length) {
            console.log("search add a fq for ", taxa);
            fq = `&fq=taxon_id:(${taxa.join(" OR ")})`;
        }
        return fetch(`${store.selectGrameneAPI()}/search?q=${store.selectGrameneFiltersQueryString()}&json.facet=${JSON.stringify($9d9aeaf9299e61a1$var$attribFacets)}&rows=0${fq}`)// return fetch(`${store.selectGrameneAPI()}/search?rows=1&q=MAKER_AED_attr_f:*&json.facet=${JSON.stringify(attribFacets)}`)
        .then((res)=>res.json()).then((res)=>{
            return res.facets;
        });
    }
});
$9d9aeaf9299e61a1$var$grameneGeneAttribs.reactGrameneGeneAttribs = (0, $gXNCa$reduxbundler.createSelector)("selectGrameneGeneAttribsShouldUpdate", "selectGrameneFiltersStatus", "selectGrameneViews", (shouldUpdate, status, views)=>{
    if (shouldUpdate && (status === "finished" || status === "ready")) {
        const byId = (0, ($parcel$interopDefault($gXNCa$lodash))).keyBy(views.options, "id");
        if (byId.attribs.show === "on") return {
            actionCreator: "doFetchGrameneGeneAttribs"
        };
    }
});
const $9d9aeaf9299e61a1$var$grameneSearch = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: "grameneSearch",
    actionBaseType: "GRAMENE_SEARCH",
    persist: false,
    getPromise: ({ store: store })=>{
        const offset = store.selectGrameneSearchOffset();
        const rows = store.selectGrameneSearchRows();
        const g = store.selectGrameneGenomes();
        const taxa = Object.keys(g.active).filter((tid)=>!g.active[tid].hidden);
        let fq = "";
        if (taxa.length) {
            console.log("search add a fq for ", taxa);
            fq = `&fq=taxon_id:(${taxa.join(" OR ")})`;
        }
        return fetch(`${store.selectGrameneAPI()}/search?q=${store.selectGrameneFiltersQueryString()}&facet.field=${$9d9aeaf9299e61a1$var$facets}&rows=${rows}&start=${offset}${fq}`).then((res)=>res.json()).then((res)=>{
            res.response.docs.forEach((d)=>{
                d.can_show = {};
                d.capabilities.forEach((c)=>{
                    d.can_show[c] = true;
                });
            });
            return res;
        });
    }
});
$9d9aeaf9299e61a1$var$grameneSearch.reactGrameneSearch = (0, $gXNCa$reduxbundler.createSelector)("selectGrameneSearchShouldUpdate", "selectGrameneFiltersStatus", "selectGrameneGenomes", "selectGrameneMaps", (shouldUpdate, status, genomes, maps)=>{
    if (shouldUpdate && status === "search" && genomes && maps) return {
        actionCreator: "doFetchGrameneSearch"
    };
});
function $9d9aeaf9299e61a1$var$formatFacetCountsForViz(a) {
    let res = {
        count: a.length / 2,
        displayName: "fixed_1000__bin",
        data: {},
        sorted: []
    };
    let counts = [];
    for(let i = 0; i < a.length; i += 2){
        const fc = {
            id: +a[i],
            count: +a[i + 1]
        };
        res.data[a[i]] = fc;
        counts.push(fc);
    }
    res.sorted = counts.sort((a, b)=>a.id - b.id);
    return res;
}
// bundle to prepare data for the TaxDist component
const $9d9aeaf9299e61a1$var$grameneTaxDist = {
    name: "grameneTaxDist",
    getReducer: ()=>{
        const initialState = {};
        return (state = initialState, { type: type, payload: payload })=>{
            return state;
        };
    },
    selectGrameneTaxDist: (0, $gXNCa$reduxbundler.createSelector)("selectGrameneSearch", "selectGrameneTaxonomy", "selectGrameneMaps", (grameneSearch, grameneTaxonomy, grameneMaps)=>{
        if (grameneSearch && grameneTaxonomy && grameneMaps) {
            (0, ($parcel$interopDefault($gXNCa$lodash))).forIn(grameneMaps, (map, tid)=>{
                grameneTaxonomy[tid].name = map.display_name;
            });
            const binnedResults = $9d9aeaf9299e61a1$var$formatFacetCountsForViz(grameneSearch.facet_counts.facet_fields.fixed_1000__bin);
            let speciesTree = (0, ($parcel$interopDefault($gXNCa$gramenetreesclient))).taxonomy.tree(Object.values(grameneTaxonomy));
            let binMapper = (0, ($parcel$interopDefault($gXNCa$gramenebinsclient))).bins(grameneMaps);
            let taxDist = (0, $gXNCa$gramenetaxonomywithgenomes.build)(binMapper, speciesTree);
            taxDist.setBinType("fixed", 1000);
            taxDist.setResults(binnedResults);
            return taxDist;
        }
        return null;
    })
};
// this query will give the sorghum orthologs of AT1G01260
// want to provide these on non-sorghum genes if available
// http://data.gramene.org/search?q=homology__all_orthologs:AT1G01260&fq=taxon_id:4558&fl=id
const $9d9aeaf9299e61a1$var$grameneOrthologs = {
    name: "grameneOrthologs",
    getReducer: ()=>{
        const initialState = {};
        return (state = initialState, { type: type, payload: payload })=>{
            let newState;
            switch(type){
                case "GRAMENE_ORTHOLOGS_REQUESTED":
                    if (!state.hasOwnProperty(payload)) {
                        newState = Object.assign({}, state);
                        newState[payload] = [];
                        return newState;
                    }
                    break;
                case "GRAMENE_ORTHOLOGS_RECEIVED":
                    return Object.assign({}, state, payload);
            }
            return state;
        };
    },
    doRequestOrthologs: (geneId)=>({ dispatch: dispatch, store: store })=>{
            const orthologs = store.selectGrameneOrthologs();
            if (!orthologs.hasOwnProperty(geneId)) {
                dispatch({
                    type: "GRAMENE_ORTHOLOGS_REQUESTED",
                    payload: geneId
                });
                const API = store.selectGrameneAPI();
                const taxonId = store.selectTargetTaxonId();
                fetch(`${API}/search?q=homology__all_orthologs:${geneId}&fq=taxon_id:${taxonId}&fl=id`).then((res)=>res.json()).then((res)=>{
                    let newOrthologs = {};
                    newOrthologs[geneId] = res.response.docs.map((d)=>d.id);
                    dispatch({
                        type: "GRAMENE_ORTHOLOGS_RECEIVED",
                        payload: newOrthologs
                    });
                });
            }
        },
    selectGrameneOrthologs: (state)=>state.grameneOrthologs
};
var // function selectFacetIDs(store, field) {
//   const path = `grameneGenes.data.facet_counts.facet_fields.${field}`;
//   if (_.has(store,path)) {
//     const flat_facets = _.get(store,path);
//     let idList = [];
//     if (isNaN(+flat_facets[0])) {
//       for (let i = 0; i < flat_facets.length; i += 2) {
//         idList.push(flat_facets[i])
//       }
//     }
//     else {
//       for (let i = 0; i < flat_facets.length; i += 2) {
//         idList.push(+flat_facets[i])
//       }
//       if (idList.length === 1) idList.push(0);
//     }
//     return idList;
//   }
// }
//
// grameneGenes.selectDomainFacets = store => selectFacetIDs(store, 'domains');
// grameneGenes.selectPathwayFacets = store => selectFacetIDs(store, 'pathways');
// grameneGenes.selectTaxonomyFacets = store => selectFacetIDs(store, 'taxon_id');
//
// const grameneDomains = createAsyncResourceBundle({
//   name: 'grameneDomains',
//   actionBaseType: 'GRAMENE_DOMAINS',
//   persist: false,
//   getPromise: ({store}) =>
//     fetch(`${store.selectGrameneAPI()}/domains?rows=-1&idList=${store.selectDomainFacets().join(',')}`)
//       .then(res => res.json())
//       .then(docs => {return {domains: docs, numFound: docs.length}})
// });
//
// const gramenePathways = createAsyncResourceBundle({
//   name: 'gramenePathways',
//   actionBaseType: 'GRAMENE_PATHWAYS',
//   persist: false,
//   getPromise: ({store}) =>
//     fetch(`${store.selectGrameneAPI()}/pathways?rows=-1&idList=${store.selectPathwayFacets().join(',')}`)
//       .then(res => res.json())
//       .then(docs => {return {pathways: docs, numFound: docs.length}})
// });
//
// const grameneTaxonomy = createAsyncResourceBundle({
//   name: 'grameneTaxonomy',
//   actionBaseType: 'GRAMENE_TAXONOMY',
//   persist: false,
//   getPromise: ({store}) =>
//     fetch(`${store.selectGrameneAPI()}/taxonomy?rows=-1&idList=${store.selectTaxonomyFacets().join(',')}`)
//       .then(res => res.json())
//       .then(docs => {return {taxonomy: docs, numFound: docs.length}})
// });
$9d9aeaf9299e61a1$export$2e2bcd8739ae039 = [
    $9d9aeaf9299e61a1$var$grameneSuggestions,
    $9d9aeaf9299e61a1$var$grameneSearch,
    $9d9aeaf9299e61a1$var$grameneMaps,
    $9d9aeaf9299e61a1$var$grameneTaxonomy,
    $9d9aeaf9299e61a1$var$grameneTaxDist,
    $9d9aeaf9299e61a1$var$grameneOrthologs,
    $9d9aeaf9299e61a1$var$curatedGenes,
    $9d9aeaf9299e61a1$var$grameneGermplasm,
    $9d9aeaf9299e61a1$var$grameneGeneAttribs,
    $9d9aeaf9299e61a1$var$expressionSamples,
    $9d9aeaf9299e61a1$var$expressionStudies
];





const $af4441dd29af05df$var$MAX_IDLIST_LENGTH = 20;
function $af4441dd29af05df$var$findNodeWithLeftIdx(node, idx) {
    if (node.leftIdx === idx) return node;
    let result = null;
    if (node.leftIdx < idx && node.hasOwnProperty("children")) node.children.forEach((child)=>{
        if (child.rightIdx > idx) {
            child.parentIdx = node.leftIdx;
            const res = $af4441dd29af05df$var$findNodeWithLeftIdx(child, idx);
            if (res) result = res;
        }
    });
    return result;
}
function $af4441dd29af05df$var$markSubtree(node, source, invert) {
    node.marked = node.leftIdx >= source.leftIdx && node.rightIdx <= source.rightIdx;
    if (invert) node.marked = !node.marked;
    if (node.hasOwnProperty("children")) node.children.forEach((child)=>{
        $af4441dd29af05df$var$markSubtree(child, source, invert);
    });
}
function $af4441dd29af05df$var$reindexTree(node, idx) {
    node.leftIdx = idx;
    idx++;
    if (node.hasOwnProperty("children")) node.children.forEach((child)=>{
        idx = $af4441dd29af05df$var$reindexTree(child, idx);
    });
    node.rightIdx = idx;
    idx++;
    return idx;
}
const $af4441dd29af05df$var$grameneFilters = {
    name: "grameneFilters",
    getReducer: ()=>{
        const initialState = {
            status: "init",
            operation: "AND",
            negate: false,
            marked: false,
            leftIdx: 0,
            rightIdx: 1,
            children: [],
            showMarked: false,
            showMenu: false,
            moveCopyMode: "",
            searchOffset: 0,
            rows: 20
        };
        return (state = initialState, { type: type, payload: payload })=>{
            let newState;
            switch(type){
                case "GRAMENE_FILTERS_CLEARED":
                    newState = Object.assign({}, initialState, {
                        status: "search",
                        children: []
                    });
                    return newState;
                case "GRAMENE_FILTER_ADDED":
                    {
                        const idx = state.rightIdx;
                        newState = Object.assign({}, state, {
                            status: "search",
                            showMarked: true,
                            rightIdx: idx + 2,
                            searchOffset: 0
                        });
                        let child = (0, ($parcel$interopDefault($gXNCa$lodash))).pick(payload, [
                            "fq_field",
                            "fq_value",
                            "name",
                            "category"
                        ]);
                        child.leftIdx = idx;
                        child.rightIdx = idx + 1;
                        child.negate = false;
                        child.showMenu = false;
                        newState.children.push(child);
                        $af4441dd29af05df$var$markSubtree(newState, child, false);
                        return newState;
                    }
                case "GRAMENE_FILTER_TREE_ADDED":
                    newState = Object.assign({}, state, {
                        status: "search",
                        showMarked: true,
                        rightIdx: payload.rightIdx + 1,
                        searchOffset: 0
                    });
                    newState.children.push(payload);
                    $af4441dd29af05df$var$markSubtree(newState, payload, false);
                    return newState;
                case "GRAMENE_FILTER_SET_ADDED":
                    {
                        // create a filter with the payload.operation and children payload.filters
                        let filter = {
                            leftIdx: state.rightIdx,
                            rightIdx: state.rightIdx + payload.filters.length * 2 + 1,
                            operation: payload.operation,
                            negate: false,
                            showMenu: false,
                            children: payload.filters
                        };
                        if (payload.warning) filter.warning = payload.warning;
                        let nextIdx = filter.leftIdx + 1;
                        payload.filters.forEach((f)=>{
                            f.leftIdx = nextIdx++;
                            f.rightIdx = nextIdx++;
                            f.negate = false;
                            f.showMenu = false;
                        });
                        newState = Object.assign({}, state, {
                            status: "search",
                            showMarked: true,
                            searchOffset: 0,
                            rightIdx: filter.rightIdx + 1
                        });
                        newState.children.push(filter);
                        $af4441dd29af05df$var$markSubtree(newState, filter, false);
                        return newState;
                    }
                case "GRAMENE_FILTER_NEGATED":
                    {
                        newState = Object.assign({}, state, {
                            status: "search",
                            showMarked: true,
                            searchOffset: 0
                        });
                        let node = $af4441dd29af05df$var$findNodeWithLeftIdx(newState, payload.leftIdx);
                        if (node) {
                            node.negate = !node.negate;
                            $af4441dd29af05df$var$markSubtree(newState, node, false);
                            return newState;
                        }
                        break;
                    }
                case "GRAMENE_FILTER_DELETED":
                    {
                        newState = Object.assign({}, state, {
                            status: "search",
                            showMarked: true,
                            searchOffset: 0
                        });
                        let node = $af4441dd29af05df$var$findNodeWithLeftIdx(newState, payload.leftIdx);
                        if (node) {
                            let parent = $af4441dd29af05df$var$findNodeWithLeftIdx(newState, node.parentIdx);
                            parent.children = parent.children.filter((child)=>child.leftIdx !== node.leftIdx);
                            $af4441dd29af05df$var$reindexTree(newState, 0);
                            $af4441dd29af05df$var$markSubtree(newState, parent, false);
                            return newState;
                        }
                        break;
                    }
                case "GRAMENE_FILTER_OPERATION_CHANGED":
                    if (payload.hasOwnProperty("operation")) {
                        newState = Object.assign({}, state, {
                            status: "search",
                            showMarked: true,
                            searchOffset: 0
                        });
                        let node = $af4441dd29af05df$var$findNodeWithLeftIdx(newState, payload.leftIdx);
                        node.operation = node.operation === "AND" ? "OR" : "AND";
                        $af4441dd29af05df$var$markSubtree(newState, node, false);
                        return newState;
                    }
                    break;
                case "GRAMENE_FILTER_MOVED":
                    {
                        newState = Object.assign({}, state, {
                            status: "search",
                            showMarked: true,
                            moveCopyMode: "",
                            searchOffset: 0
                        });
                        let source = $af4441dd29af05df$var$findNodeWithLeftIdx(newState, payload.source.leftIdx);
                        let target = $af4441dd29af05df$var$findNodeWithLeftIdx(newState, payload.target.leftIdx);
                        if (source && target) {
                            source.showMenu = false;
                            let parent = $af4441dd29af05df$var$findNodeWithLeftIdx(newState, source.parentIdx);
                            parent.children = parent.children.filter((child)=>child.leftIdx !== source.leftIdx);
                            target.showMenu = false;
                            if (!target.hasOwnProperty("children")) {
                                let targetCopy = Object.assign({}, target);
                                target.children = [
                                    targetCopy
                                ];
                                target.operation = "OR";
                                target.negate = false;
                                delete target.fq_field;
                                delete target.fq_value;
                                delete target.name;
                                delete target.category;
                            }
                            target.children.push(source);
                            $af4441dd29af05df$var$reindexTree(newState, 0);
                            $af4441dd29af05df$var$markSubtree(newState, target, false);
                            return newState;
                        }
                        break;
                    }
                case "GRAMENE_FILTER_COPIED":
                    {
                        newState = Object.assign({}, state, {
                            status: "search",
                            showMarked: true,
                            moveCopyMode: "",
                            searchOffset: 0
                        });
                        let source = $af4441dd29af05df$var$findNodeWithLeftIdx(newState, payload.source.leftIdx);
                        let target = $af4441dd29af05df$var$findNodeWithLeftIdx(newState, payload.target.leftIdx);
                        if (source && target) {
                            source.showMenu = false;
                            if (!target.hasOwnProperty("children")) {
                                let targetCopy = Object.assign({}, target);
                                target.children = [
                                    targetCopy
                                ];
                                target.operation = "OR";
                                target.negate = false;
                                delete target.fq_field;
                                delete target.fq_value;
                                delete target.name;
                                delete target.category;
                            }
                            let sourceCopy = Object.assign({}, source);
                            target.children.push(sourceCopy);
                            $af4441dd29af05df$var$reindexTree(newState, 0);
                            $af4441dd29af05df$var$markSubtree(newState, target, false);
                            return newState;
                        }
                        break;
                    }
                case "GRAMENE_FILTER_TARGETS_MARKED":
                    newState = Object.assign({}, state, {
                        showMarked: true,
                        moveCopyMode: payload.mode,
                        moveCopySource: payload.source
                    });
                    $af4441dd29af05df$var$markSubtree(newState, payload.source, true);
                    return newState;
                case "GRAMENE_FILTER_TARGETS_UNMARKED":
                    newState = Object.assign({}, state, {
                        showMarked: false
                    });
                    return newState;
                case "GRAMENE_FILTERS_REPLACED":
                    payload.status = "search";
                    payload.searchOffset = 0;
                    return payload;
                case "GRAMENE_FILTERS_STATUS_CHANGED":
                    if (!(state.status === "ready" && payload === "waiting")) return Object.assign({}, state, {
                        status: payload
                    });
                    break;
                case "GRAMENE_FILTERS_SET_SHOW_MARKED":
                    return Object.assign({}, state, {
                        showMarked: payload
                    });
                case "GRAMENE_FILTER_MENU_TOGGLED":
                    payload.showMenu = !payload.showMenu;
                    return Object.assign({}, state);
                case "GRAMENE_SEARCH_PAGE_REQUESTED":
                    return Object.assign({}, state, {
                        status: "search",
                        searchOffset: payload * state.rows
                    });
                case "GRAMENE_SEARCH_FETCH_STARTED":
                    return Object.assign({}, state, {
                        status: "loading"
                    });
                case "GRAMENE_SEARCH_FETCH_FINISHED":
                    return Object.assign({}, state, {
                        status: "finished"
                    });
                case "GRAMENE_GENOMES_UPDATED":
                    return Object.assign({}, state, {
                        status: "search"
                    });
                case "URL_UPDATED":
                    if (state.status === "ready") return Object.assign({}, initialState, {
                        children: []
                    });
                    break;
                case "APP_IDLE":
                    if (state.showMarked) return Object.assign({}, state, {
                        showMarked: false
                    });
            }
            return state;
        };
    },
    doNegateGrameneFilter: (filter)=>({ dispatch: dispatch, getState: getState })=>{
            dispatch({
                type: "BATCH_ACTIONS",
                actions: [
                    {
                        type: "GRAMENE_SEARCH_CLEARED"
                    },
                    {
                        type: "GRAMENE_FILTER_NEGATED",
                        payload: filter
                    }
                ]
            });
        },
    doDeleteGrameneFilter: (filter)=>({ dispatch: dispatch })=>{
            dispatch({
                type: "BATCH_ACTIONS",
                actions: [
                    {
                        type: "GRAMENE_SEARCH_CLEARED"
                    },
                    {
                        type: "GRAMENE_TAXONOMY_CLEARED"
                    },
                    {
                        type: "GRAMENE_FILTER_DELETED",
                        payload: filter
                    }
                ]
            });
        },
    doChangeGrameneFilterOperation: (filter)=>({ dispatch: dispatch })=>{
            dispatch({
                type: "BATCH_ACTIONS",
                actions: [
                    {
                        type: "GRAMENE_SEARCH_CLEARED"
                    },
                    {
                        type: "GRAMENE_FILTER_OPERATION_CHANGED",
                        payload: filter
                    }
                ]
            });
        },
    doMoveOrCopyGrameneFilter: (target)=>({ dispatch: dispatch, getState: getState })=>{
            const state = getState();
            if (state.grameneFilters.moveCopyMode) {
                const source = state.grameneFilters.moveCopySource;
                dispatch({
                    type: "BATCH_ACTIONS",
                    actions: [
                        {
                            type: "GRAMENE_SEARCH_CLEARED"
                        },
                        {
                            type: `GRAMENE_FILTER_${state.grameneFilters.moveCopyMode.toUpperCase()}D`,
                            payload: {
                                source: source,
                                target: target
                            }
                        }
                    ]
                });
            }
        },
    doCopyGrameneFilter: (source, target)=>({ dispatch: dispatch, getState: getState })=>{
            dispatch({
                type: "BATCH_ACTIONS",
                actions: [
                    {
                        type: "GRAMENE_SEARCH_CLEARED"
                    },
                    {
                        type: "GRAMENE_FILTER_COPIED",
                        payload: {
                            source: source,
                            target: target
                        }
                    }
                ]
            });
        },
    doMarkGrameneFilterTargets: (source, mode)=>({ dispatch: dispatch })=>{
            dispatch({
                type: "GRAMENE_FILTER_TARGETS_MARKED",
                payload: {
                    source: source,
                    mode: mode
                }
            });
        },
    doUnmarkGrameneFilterTargets: ()=>({ dispatch: dispatch })=>{
            dispatch({
                type: "GRAMENE_FILTER_TARGETS_UNMARKED"
            });
        },
    doAcceptGrameneSuggestion: (suggestion)=>({ dispatch: dispatch, getState: getState })=>{
            if (!suggestion.name) suggestion.name = suggestion.display_name;
            dispatch({
                type: "BATCH_ACTIONS",
                actions: [
                    {
                        type: "GRAMENE_SEARCH_CLEARED"
                    },
                    {
                        type: "GRAMENE_FILTER_ADDED",
                        payload: suggestion
                    }
                ]
            });
        },
    doAddGrameneRangeQuery: (terms)=>({ dispatch: dispatch })=>{
            dispatch({
                type: "BATCH_ACTIONS",
                actions: [
                    {
                        type: "GRAMENE_SEARCH_CLEARED"
                    },
                    {
                        type: "GRAMENE_FILTER_SET_ADDED",
                        payload: {
                            operation: "AND",
                            filters: terms
                        }
                    }
                ]
            });
        },
    doToggleGrameneFilterMenu: (node)=>({ dispatch: dispatch })=>{
            dispatch({
                type: "GRAMENE_FILTER_MENU_TOGGLED",
                payload: node
            });
        },
    doRequestResultsPage: (page)=>({ dispatch: dispatch })=>{
            dispatch({
                type: "BATCH_ACTIONS",
                actions: [
                    {
                        type: "GRAMENE_SEARCH_CLEARED"
                    },
                    {
                        type: "GRAMENE_SEARCH_PAGE_REQUESTED",
                        payload: page
                    }
                ]
            });
        },
    doReplaceGrameneFilters: (filters)=>({ dispatch: dispatch })=>{
            dispatch({
                type: "BATCH_ACTIONS",
                actions: [
                    {
                        type: "GRAMENE_SEARCH_CLEARED"
                    },
                    {
                        type: "GRAMENE_FILTERS_REPLACED",
                        payload: filters
                    }
                ]
            });
        },
    doClearGrameneFilters: ()=>({ dispatch: dispatch })=>{
            dispatch({
                type: "BATCH_ACTIONS",
                actions: [
                    {
                        type: "GRAMENE_SEARCH_CLEARED"
                    },
                    {
                        type: "GRAMENE_FILTERS_CLEARED"
                    }
                ]
            });
        },
    selectGrameneFilters: (state)=>state.grameneFilters,
    selectGrameneFiltersStatus: (state)=>state.grameneFilters.status,
    selectGrameneFiltersQueryString: (state)=>{
        const hasSpaces = new RegExp(/^[^\[\(].*\s/);
        const isQuery = new RegExp(/\([a-zA-Z0-9_]+:[a-zA-Z0-9_]+\s/);
        const isRegionQuery = new RegExp(/^\(map:/);
        const idWithColon = new RegExp(/^[a-zA-Z0-9_]+:[a-zA-Z0-9_]+$/);
        function getQuery(node) {
            const negate = node.negate ? "NOT " : "";
            if (node.hasOwnProperty("children")) // do some recursion
            return `${negate}(${node.children.map((c)=>getQuery(c)).sort().join(` ${node.operation} `)})`;
            else {
                // this node is a suggestion
                if (node.fq_field === "location" && isRegionQuery.test(node.fq_value)) return `${negate}${node.fq_value}`;
                if (isQuery.test(node.fq_value)) return `${negate}${node.fq_value.replace(/:/g, "\\:")}`;
                if (hasSpaces.test(node.fq_value)) return `${negate}${node.fq_field}:"${node.fq_value}"`;
                else if (idWithColon.test(node.fq_value)) return `${negate}${node.fq_field}:${node.fq_value.replace(/:/g, "\\:")}`;
                else return `${negate}${node.fq_field}:${node.fq_value}`;
            }
        }
        if (state.grameneFilters.rightIdx === 1) return "*:*";
        return `*:* AND (${getQuery(state.grameneFilters)})`;
    },
    selectGrameneSearchOffset: (state)=>state.grameneFilters.searchOffset,
    selectGrameneSearchRows: (state)=>state.grameneFilters.rows
};
const $af4441dd29af05df$var$handleIdList = (queryObject)=>{
    let actions = [
        {
            type: "GRAMENE_SEARCH_CLEARED"
        }
    ];
    let ids = (0, ($parcel$interopDefault($gXNCa$lodash))).uniq(queryObject.idList.split(","));
    let warning = null;
    if (ids.length > $af4441dd29af05df$var$MAX_IDLIST_LENGTH) {
        ids = (0, ($parcel$interopDefault($gXNCa$lodash))).slice(ids, 0, $af4441dd29af05df$var$MAX_IDLIST_LENGTH);
        warning = `The idList query parameter is limited to ${$af4441dd29af05df$var$MAX_IDLIST_LENGTH} genes`;
    }
    let filters = ids.map((id, idx)=>{
        return {
            category: "Gene",
            name: id,
            fq_field: "id",
            fq_value: id
        };
    });
    if (filters.length === 1) actions.push({
        type: "GRAMENE_FILTER_ADDED",
        payload: filters[0]
    });
    else {
        let action = {
            type: "GRAMENE_FILTER_SET_ADDED",
            payload: {
                operation: "OR",
                filters: filters
            }
        };
        if (warning) action.payload.warning = warning;
        actions.push(action);
    }
    return {
        type: "BATCH_ACTIONS",
        actions: actions
    };
};
$af4441dd29af05df$var$grameneFilters.reactGrameneFilters = (0, $gXNCa$reduxbundler.createSelector)("selectQueryObject", "selectGrameneFilters", "selectActiveGenomes", "selectUrlObject", (queryObject, filters, genomes, myUrl)=>{
    if (filters.status === "init") {
        if (queryObject.filters) {
            const newFilters = JSON.parse(queryObject.filters);
            let actions = [
                {
                    type: "GRAMENE_SEARCH_CLEARED"
                },
                {
                    type: "GRAMENE_FILTERS_REPLACED",
                    payload: newFilters
                }
            ];
            if (queryObject.genomes) {
                let active = {};
                queryObject.genomes.split(",").forEach((t)=>{
                    active[t] = true;
                });
                actions.push({
                    type: "GRAMENE_GENOMES_UPDATED",
                    payload: active
                });
            }
            return {
                type: "BATCH_ACTIONS",
                actions: actions
            };
        }
        if (queryObject.hasOwnProperty("suggestion")) return {
            type: "BATCH_ACTIONS",
            actions: [
                {
                    type: "GRAMENE_SEARCH_CLEARED"
                },
                {
                    type: "GRAMENE_FILTER_ADDED",
                    payload: JSON.parse(queryObject.suggestion)
                }
            ]
        };
        if (queryObject.hasOwnProperty("idList")) return $af4441dd29af05df$var$handleIdList(queryObject);
        if (queryObject.hasOwnProperty("fq_field") && queryObject.hasOwnProperty("fq_value") && queryObject.hasOwnProperty("category") && queryObject.hasOwnProperty("name")) return {
            type: "BATCH_ACTIONS",
            actions: [
                {
                    type: "GRAMENE_SEARCH_CLEARED"
                },
                {
                    type: "GRAMENE_FILTER_ADDED",
                    payload: queryObject
                }
            ]
        };
        const url = new URL(myUrl.href);
        if (url.pathname === "/genes") return {
            type: "GRAMENE_FILTERS_CLEARED"
        };
    }
    if (filters.status === "finished") {
        const url = new URL(myUrl.href);
        url.search = `filters=${JSON.stringify(Object.assign({}, filters, {
            status: "init"
        }))}&genomes=${genomes.join(",")}`;
        (0, ($parcel$interopDefault($gXNCa$reactga4))).event({
            category: "Gene Search",
            action: "filter finished",
            label: url.search
        });
        return {
            type: "BATCH_ACTIONS",
            actions: [
                {
                    type: "URL_UPDATED",
                    payload: {
                        url: url.href,
                        replace: false
                    }
                },
                {
                    type: "GRAMENE_FILTERS_STATUS_CHANGED",
                    payload: "ready"
                }
            ]
        };
    }
});
var $af4441dd29af05df$export$2e2bcd8739ae039 = $af4441dd29af05df$var$grameneFilters;


const $24971af0a229e0e3$var$grameneViews = {
    name: "grameneViews",
    getReducer: ()=>{
        const initialState = {
            options: [
                {
                    id: "help",
                    name: "Help / Demo",
                    show: "off",
                    shouldScroll: false
                },
                {
                    id: "userLists",
                    name: "User Gene Lists",
                    show: "off",
                    shouldScroll: false
                },
                {
                    id: "taxonomy",
                    name: "Taxonomic distribution",
                    show: "on",
                    shouldScroll: false
                },
                {
                    id: "list",
                    name: "Gene list",
                    show: "on",
                    shouldScroll: false
                },
                {
                    id: "expression",
                    name: "Gene expression",
                    show: "off",
                    shouldScroll: false,
                    desiredSamples: {}
                },
                {
                    id: "attribs",
                    name: "Gene attributes",
                    show: "disabled",
                    shouldScroll: false
                }
            ]
        };
        return (state = initialState, { type: type, payload: payload })=>{
            let newState;
            switch(type){
                case "GRAMENE_VIEW_TOGGLED":
                    newState = Object.assign({}, state);
                    newState.options.forEach((view)=>{
                        view.shouldScroll = false;
                        if (view.id === payload) {
                            view.show = view.show === "on" ? "off" : "on";
                            view.shouldScroll = view.show === "on";
                        }
                    });
                    return newState;
                case "GRAMENE_VIEW_CLICKED":
                    newState = Object.assign({}, state);
                    newState.options.forEach((view)=>{
                        view.shouldScroll = false;
                        if (view.id === payload) {
                            view.show = view.show === "on" ? "on" : "on";
                            view.shouldScroll = view.show === "on";
                        }
                    });
                    return newState;
                case "GRAMENE_VIEW_SCROLLED":
                    newState = Object.assign({}, state);
                    newState.options.forEach((v)=>v.shouldScroll = false);
                    return newState;
                default:
                    return state;
            }
        };
    },
    doToggleGrameneView: (idx)=>({ dispatch: dispatch, getState: getState })=>{
            dispatch({
                type: "GRAMENE_VIEW_TOGGLED",
                payload: idx
            });
        },
    dontToggleGrameneView: (idx)=>({ dispatch: dispatch, getState: getState })=>{
            dispatch({
                type: "GRAMENE_VIEW_CLICKED",
                payload: idx
            });
        },
    doCancelShouldScroll: ()=>({ dispatch: dispatch, getState: getState })=>{
            dispatch({
                type: "GRAMENE_VIEW_SCROLLED",
                payload: null
            });
        },
    selectGrameneViews: (state)=>state.grameneViews
};
var $24971af0a229e0e3$export$2e2bcd8739ae039 = $24971af0a229e0e3$var$grameneViews;


const $671312b287158a8a$var$grameneDocs = {
    name: "grameneDocs",
    getReducer: ()=>{
        const initialState = {
            genes: {},
            trees: {},
            domains: {},
            pathways: {},
            expression: {},
            sequences: {},
            rnaSequences: {},
            pepSequences: {},
            studies: {},
            desiredSamples: {},
            consequences: {}
        };
        return (state = initialState, { type: type, payload: payload })=>{
            let newState;
            switch(type){
                case "GRAMENE_CONSEQUENCES_REQUESTED":
                    if (!state.consequences.hasOwnProperty(payload)) {
                        newState = Object.assign({}, state);
                        newState.consequences[payload] = {};
                        return newState;
                    }
                    break;
                case "GRAMENE_CONSEQUENCES_RECEIVED":
                    newState = Object.assign({}, state);
                    newState.consequences = Object.assign({}, state.consequences, payload);
                    return newState;
                case "GRAMENE_GENE_REQUESTED":
                    if (!state.genes.hasOwnProperty(payload)) {
                        newState = Object.assign({}, state);
                        newState.genes[payload] = {};
                        return newState;
                    }
                    break;
                case "GRAMENE_GENE_RECEIVED":
                    newState = Object.assign({}, state);
                    newState.genes = Object.assign({}, state.genes, payload);
                    return newState;
                case "GRAMENE_TREE_REQUESTED":
                    if (!state.trees.hasOwnProperty(payload)) {
                        newState = Object.assign({}, state);
                        newState.trees[payload] = {};
                        return newState;
                    }
                    break;
                case "GRAMENE_TREE_RECEIVED":
                    newState = Object.assign({}, state);
                    newState.trees = Object.assign({}, state.trees, payload);
                    return newState;
                case "GRAMENE_PATHWAYS_RECEIVED":
                    newState = Object.assign({}, state);
                    newState.pathways = Object.assign({}, state.pathways, payload);
                    return newState;
                case "ATLAS_STUDIES_RECEIVED":
                    newState = Object.assign({}, state);
                    newState.studies = Object.assign({}, state.studies, payload);
                    return newState;
                case "ATLAS_SAMPLES_REQUESTED":
                    if (!state.studies.byID[payload].hasOwnProperty("samples")) {
                        newState = Object.assign({}, state);
                        newState.studies.byID[payload].samples = [];
                        return newState;
                    }
                    break;
                case "ATLAS_SAMPLES_RECEIVED":
                    newState = Object.assign({}, state);
                    newState.studies.byID[payload.id].samples = payload.samples;
                    return newState;
                case "GENE_SEQUENCE_REQUESTED":
                    if (!state.sequences.hasOwnProperty(payload)) {
                        newState = Object.assign({}, state);
                        newState.sequences[payload] = {};
                        return newState;
                    }
                    break;
                case "RNA_SEQUENCE_REQUESTED":
                    if (!state.rnaSequences.hasOwnProperty(payload)) {
                        newState = Object.assign({}, state);
                        newState.rnaSequences[payload] = {};
                        return newState;
                    }
                    break;
                case "PEP_SEQUENCE_REQUESTED":
                    if (!state.rnaSequences.hasOwnProperty(payload)) {
                        newState = Object.assign({}, state);
                        newState.pepSequences[payload] = {};
                        return newState;
                    }
                    break;
                case "GENE_SEQUENCE_RECEIVED":
                    newState = Object.assign({}, state);
                    newState.sequences = Object.assign({}, state.sequences);
                    newState.sequences[payload.id] = payload.geneSeq;
                    return newState;
                case "RNA_SEQUENCE_RECEIVED":
                    newState = Object.assign({}, state);
                    newState.rnaSequences = Object.assign({}, state.rnaSequences);
                    newState.rnaSequences[payload.id] = payload.RnaSeq;
                    return newState;
                case "PEP_SEQUENCE_RECEIVED":
                    newState = Object.assign({}, state);
                    newState.pepSequences = Object.assign({}, state.pepSequences);
                    newState.pepSequences[payload.id] = payload.PepSeq;
                    return newState;
                case "PARALOG_EXPRESSION_REQUESTED":
                    if (!state.expression.hasOwnProperty(payload)) {
                        newState = Object.assign({}, state);
                        newState.expression[payload] = [];
                        return newState;
                    }
                    break;
                case "PARALOG_EXPRESSION_RECEIVED":
                    newState = Object.assign({}, state);
                    newState.expression = Object.assign({}, state.expression);
                    newState.expression[payload.id] = payload.paralogs;
                    return newState;
                case "EXPRESSION_SAMPLE_TOGGLED":
                    newState = Object.assign({}, state);
                    newState.desiredSamples = Object.assign({}, state.desiredSamples);
                    if (newState.desiredSamples.hasOwnProperty(payload)) delete newState.desiredSamples[payload];
                    else newState.desiredSamples[payload] = {
                        status: "need"
                    };
            }
            return state;
        };
    },
    doToggleExpressionSample: (id)=>({ dispatch: dispatch })=>{
            dispatch({
                type: "EXPRESSION_SAMPLE_TOGGLED",
                payload: id
            });
        },
    doRequestVEP: (id)=>({ dispatch: dispatch, store: store })=>{
            const consequences = store.selectGrameneConsequences();
            if (!consequences.hasOwnProperty(id)) {
                dispatch({
                    type: "GRAMENE_CONSEQUENCES_REQUESTED",
                    payload: id
                });
                fetch(`${store.selectGrameneAPI()}/search?q=id:${id}&fl=id,VEP__*`).then((res)=>res.json()).then((res)=>{
                    let genes = {};
                    res.response.docs.forEach((g)=>{
                        genes[g.id] = g;
                    });
                    dispatch({
                        type: "GRAMENE_CONSEQUENCES_RECEIVED",
                        payload: genes
                    });
                });
            }
        },
    doRequestGrameneGene: (id)=>({ dispatch: dispatch, store: store })=>{
            const genes = store.selectGrameneGenes();
            if (!genes.hasOwnProperty(id)) {
                dispatch({
                    type: "GRAMENE_GENE_REQUESTED",
                    payload: id
                });
                fetch(`${store.selectGrameneAPI()}/genes?idList=${id}`).then((res)=>res.json()).then((res)=>{
                    let genes = {};
                    res.forEach((g)=>{
                        genes[g._id] = g;
                    });
                    dispatch({
                        type: "GRAMENE_GENE_RECEIVED",
                        payload: genes
                    });
                });
            }
        },
    doRequestGrameneTree: (id)=>({ dispatch: dispatch, store: store })=>{
            const trees = store.selectGrameneTrees();
            const maps = store.selectGrameneMaps();
            if (!trees.hasOwnProperty(id)) {
                dispatch({
                    type: "GRAMENE_TREE_REQUESTED",
                    payload: id
                });
                fetch(`${store.selectGrameneAPI()}/genetrees?idList=${id}`).then((res)=>res.json()).then((res)=>{
                    let trees = {};
                    res.forEach((t)=>{
                        function update_taxon_name(node) {
                            if (maps.hasOwnProperty(node.taxon_id)) node.taxon_name = maps[node.taxon_id].display_name;
                            else if (node.taxon_id === 1100004558) node.taxon_name = "Sorghum bicolor";
                            if (node.taxon_id === 45580023 && node.hasOwnProperty("children")) node.taxon_name = "Sorghum bicolor";
                            if (node.taxon_id === 45770001 && node.hasOwnProperty("children")) node.taxon_name = "Zea mays";
                            if (node.taxon_id === 297600009 && node.hasOwnProperty("children")) node.taxon_name = "Vitis vinifera";
                            if (node.hasOwnProperty("children")) node.children.forEach((c)=>update_taxon_name(c));
                        }
                        update_taxon_name(t);
                        trees[t._id] = t;
                    });
                    dispatch({
                        type: "GRAMENE_TREE_RECEIVED",
                        payload: trees
                    });
                });
            }
        },
    doRequestGramenePathways: (ids)=>({ dispatch: dispatch, store: store })=>{
            const pathways = store.selectGramenePathways();
            let newIds = ids.filter((id)=>!pathways.hasOwnProperty(id));
            if (newIds) {
                dispatch({
                    type: "GRAMENE_PATHWAYS_REQUESTED",
                    payload: newIds
                });
                if (newIds.length === 1) newIds.push(0);
                fetch(`${store.selectGrameneAPI()}/pathways?idList=${newIds.join(",")}`).then((res)=>res.json()).then((res)=>{
                    let pathways = {};
                    res.forEach((p)=>{
                        pathways[p._id] = p;
                    });
                    dispatch({
                        type: "GRAMENE_PATHWAYS_RECEIVED",
                        payload: pathways
                    });
                });
            }
        },
    doRequestExpressionStudies: (id)=>({ dispatch: dispatch, store: store })=>{
            fetch(`${store.selectGrameneAPI()}/experiments?rows=-1`).then((res)=>res.json()).then((res)=>{
                let studies = {
                    byID: {},
                    byTaxon: {}
                };
                res.forEach((s)=>{
                    studies.byID[s._id] = s;
                    if (!studies.byTaxon.hasOwnProperty(s.taxon_id)) studies.byTaxon[s.taxon_id] = [];
                    studies.byTaxon[s.taxon_id].push(s._id);
                });
                dispatch({
                    type: "ATLAS_STUDIES_RECEIVED",
                    payload: studies
                });
            });
        },
    doRequestStudyMetadata: (id)=>({ dispatch: dispatch, store: store })=>{
            const studies = store.selectAtlasStudies();
            if (!studies.byID[id].hasOwnProperty("samples")) {
                dispatch({
                    type: "ATLAS_SAMPLES_REQUESTED",
                    payload: id
                });
                fetch(`${store.selectGrameneAPI()}/assays?experiment=${id}&rows=-1`).then((res)=>res.json()).then((samples)=>{
                    dispatch({
                        type: "ATLAS_SAMPLES_RECEIVED",
                        payload: {
                            id: id,
                            samples: samples
                        }
                    });
                });
            }
        },
    doRequestGeneSequence: (gene)=>({ dispatch: dispatch, store: store })=>{
            const maps = store.selectGrameneMaps();
            const seqs = store.selectGeneSequences();
            const id = gene._id;
            const MAX_FLANK = 2000;
            if (!seqs.hasOwnProperty(id)) {
                dispatch({
                    type: "GENE_SEQUENCE_REQUESTED",
                    payload: id
                });
                const start = gene.location.start > MAX_FLANK ? gene.location.start - MAX_FLANK : 1;
                const dnaLength = maps[gene.taxon_id].regionLength[gene.location.region];
                const end = gene.location.end + MAX_FLANK > dnaLength ? dnaLength : gene.location.end + MAX_FLANK;
                fetch(`${store.selectEnsemblAPI()}/sequence/region/${gene.system_name}/${gene.location.region}:${start}..${end}:${gene.location.strand}?content-type=application/json`).then((res)=>res.json()).then((geneSeq)=>{
                    const x = geneSeq.id.split(":");
                    geneSeq.genome = x[1];
                    geneSeq.start = +x[3];
                    geneSeq.end = +x[4];
                    dispatch({
                        type: "GENE_SEQUENCE_RECEIVED",
                        payload: {
                            id: id,
                            geneSeq: geneSeq
                        }
                    });
                });
            }
        },
    doRequestRnaSequence: (id, gene)=>({ dispatch: dispatch, store: store })=>{
            const seqs = store.selectRnaSequences();
            if (!seqs.hasOwnProperty(id)) {
                dispatch({
                    type: "RNA_SEQUENCE_REQUESTED",
                    payload: id
                });
                fetch(`${store.selectEnsemblAPI()}/sequence/id/${id}?species=${gene.system_name}&type=cdna&content-type=application/json`).then((res)=>res.json()).then((RnaSeq)=>{
                    dispatch({
                        type: "RNA_SEQUENCE_RECEIVED",
                        payload: {
                            id: id,
                            RnaSeq: RnaSeq
                        }
                    });
                });
            }
        },
    doRequestPepSequence: (id, gene)=>({ dispatch: dispatch, store: store })=>{
            const seqs = store.selectPepSequences();
            if (!seqs.hasOwnProperty(id)) {
                dispatch({
                    type: "PEP_SEQUENCE_REQUESTED",
                    payload: id
                });
                fetch(`${store.selectEnsemblAPI()}/sequence/id/${id}?species=${gene.system_name}&type=protein&content-type=application/json`).then((res)=>res.json()).then((PepSeq)=>{
                    dispatch({
                        type: "PEP_SEQUENCE_RECEIVED",
                        payload: {
                            id: id,
                            PepSeq: PepSeq
                        }
                    });
                });
            }
        },
    doRequestParalogExpression: (id)=>({ dispatch: dispatch, store: store })=>{
            const expr = store.selectParalogExpression();
            if (!expr.hasOwnProperty(id)) {
                dispatch({
                    type: "PARALOG_EXPRESSION_REQUESTED",
                    payload: id
                });
                fetch(`${store.selectGrameneAPI()}/search?q=homology__within_species_paralog:${id}&fl=id,atlas_id,name,*__expr&rows=100`).then((res)=>res.json()).then((res)=>{
                    const assay_re = /(.+)_g(\d+)/;
                    const paralogs = res.response.docs.map((d)=>{
                        let p = {
                            id: d.id,
                            name: d.name,
                            experiments: {},
                            min: 1000,
                            max: 0
                        };
                        if (d.atlas_id) {
                            p.atlas_id = d.atlas_id;
                            delete d.atlas_id;
                        }
                        delete d.id;
                        delete d.name;
                        Object.entries(d).forEach((assay)=>{
                            const parsed = assay[0].match(assay_re);
                            const expr = parsed[1].replace("_", "-").replace("-tpms", "");
                            if (!p.experiments.hasOwnProperty(expr)) p.experiments[expr] = [];
                            const g = parsed[2] - 1;
                            const e = d[assay[0]];
                            if (e < p.min) p.min = e;
                            if (e > p.max) p.max = e;
                            p.experiments[expr][g] = e;
                        });
                        return p;
                    }).map((p)=>{
                        for(const expr in p.experiments)p.experiments[expr] = p.experiments[expr].filter((e)=>e >= 0);
                        return p;
                    });
                    dispatch({
                        type: "PARALOG_EXPRESSION_RECEIVED",
                        payload: {
                            id: id,
                            paralogs: paralogs
                        }
                    });
                });
            }
        },
    selectGrameneGenes: (state)=>state.grameneDocs.genes,
    selectGrameneConsequences: (state)=>state.grameneDocs.consequences,
    selectGrameneTrees: (state)=>state.grameneDocs.trees,
    selectGramenePathways: (state)=>state.grameneDocs.pathways,
    selectParalogExpression: (state)=>state.grameneDocs.expression,
    selectGeneSequences: (state)=>state.grameneDocs.sequences,
    selectRnaSequences: (state)=>state.grameneDocs.rnaSequences,
    selectPepSequences: (state)=>state.grameneDocs.pepSequences,
    selectAtlasStudies: (state)=>state.grameneDocs.studies,
    selectDesiredSamples: (state)=>state.grameneDocs.desiredSamples
};
var $671312b287158a8a$export$2e2bcd8739ae039 = $671312b287158a8a$var$grameneDocs;



const $0d54502f6cafe273$var$grameneGenomes = {
    name: "grameneGenomes",
    getReducer: ()=>{
        const initialState = {
            show: false,
            active: {}
        };
        return (state = initialState, { type: type, payload: payload })=>{
            let newState;
            switch(type){
                case "GRAMENE_GENOMES_TOGGLED":
                    newState = Object.assign({}, state);
                    newState.show = !newState.show;
                    return newState;
                case "GRAMENE_GENOMES_UPDATED":
                    newState = Object.assign({}, state);
                    newState.active = payload;
                    return newState;
                case "GRAMENE_MAPS_FETCH_FINISHED":
                    newState = Object.assign({}, state);
                    newState.active = payload;
                default:
                    return state;
            }
        };
    },
    doShowGrameneGenomes: ()=>({ dispatch: dispatch, getState: getState })=>{
            dispatch({
                type: "GRAMENE_GENOMES_TOGGLED"
            });
        },
    doInitializeGrameneGenomes: (genomes)=>({ dispatch: dispatch, getState: getState })=>{
            dispatch({
                type: "BATCH_ACTIONS",
                actions: [
                    {
                        type: "GRAMENE_SEARCH_CLEARED"
                    },
                    {
                        type: "GRAMENE_GENOMES_UPDATED",
                        payload: genomes
                    }
                ]
            });
        },
    doUpdateGrameneGenomes: (genomes)=>({ dispatch: dispatch, getState: getState })=>{
            dispatch({
                type: "BATCH_ACTIONS",
                actions: [
                    {
                        type: "GRAMENE_SEARCH_CLEARED"
                    },
                    {
                        type: "GRAMENE_GENOMES_TOGGLED"
                    },
                    {
                        type: "GRAMENE_GENOMES_UPDATED",
                        payload: genomes
                    }
                ]
            });
        },
    doEnsureGrameneGenome: (genome)=>({ dispatch: dispatch, getState: getState })=>{
            const state = getState();
            if (Object.keys(state.grameneGenomes.active).length > 0 && !state.grameneGenomes.active.hasOwnProperty(genome)) {
                let active = Object.assign({}, state.grameneGenomes.active);
                active[genome] = true;
                dispatch({
                    type: "GRAMENE_GENOMES_UPDATED",
                    payload: active
                });
            }
        },
    selectGrameneGenomes: (state)=>state.grameneGenomes,
    selectActiveGenomes: (state)=>{
        return Object.keys(state.grameneGenomes.active);
    },
    selectActiveGenomeCount: (0, $gXNCa$reduxbundler.createSelector)("selectGrameneMaps", "selectGrameneGenomes", (maps, genomes)=>{
        if (maps && genomes) return Object.keys(genomes.active).length || Object.keys(maps).length;
        return 0;
    })
};
var $0d54502f6cafe273$export$2e2bcd8739ae039 = $0d54502f6cafe273$var$grameneGenomes;


var $5df6c55c1bef3469$export$2e2bcd8739ae039 = [
    ...(0, $9d9aeaf9299e61a1$export$2e2bcd8739ae039),
    (0, $671312b287158a8a$export$2e2bcd8739ae039),
    (0, $af4441dd29af05df$export$2e2bcd8739ae039),
    (0, $24971af0a229e0e3$export$2e2bcd8739ae039),
    (0, $0d54502f6cafe273$export$2e2bcd8739ae039)
];





const $2fec4872fbf7ebd2$var$Gene = ({ gene: gene })=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "row",
        children: gene.id
    });
};
const $2fec4872fbf7ebd2$var$Genes = (results, rows, doChangeQuantity)=>{
    if (results && results.numFound > 0) {
        const moreButton = results.numFound > rows ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
            onClick: (e)=>doChangeQuantity("Genes", 20),
            children: "more"
        }) : "";
        const fewerButton = rows > 20 ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
            onClick: (e)=>doChangeQuantity("Genes", -20),
            children: "fewer"
        }) : "";
        const docsToShow = results.response.docs.slice(0, rows);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            id: "Genes",
            className: "container mb40 anchor",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                    className: "fancy-title mb40",
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h4", {
                        children: "Genes"
                    })
                }),
                docsToShow.map((doc, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($2fec4872fbf7ebd2$var$Gene, {
                        gene: doc
                    }, idx)),
                fewerButton,
                moreButton
            ]
        });
    }
};
const $2fec4872fbf7ebd2$var$Pathway = ({ pathway: pathway })=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "row",
        children: pathway.name
    });
};
const $2fec4872fbf7ebd2$var$Pathways = (results)=>{
    if (results && results.numFound > 0) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        id: "Pathways",
        className: "container mb40 anchor",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "fancy-title",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h4", {
                    children: "Pathways"
                })
            }),
            results.pathways.map((doc, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($2fec4872fbf7ebd2$var$Pathway, {
                    pathway: doc
                }, idx))
        ]
    });
};
const $2fec4872fbf7ebd2$var$Domain = ({ domain: domain })=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "row",
        children: domain.id
    });
};
const $2fec4872fbf7ebd2$var$Domains = (results)=>{
    if (results && results.numFound > 0) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        id: "Domains",
        className: "container mb40 anchor",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "fancy-title mb40",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h4", {
                    children: "Domains"
                })
            }),
            results.domains.map((doc, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($2fec4872fbf7ebd2$var$Domain, {
                    domain: doc
                }, idx))
        ]
    });
};
const $2fec4872fbf7ebd2$var$Taxon = ({ taxon: taxon })=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "row",
        children: taxon.id
    });
};
const $2fec4872fbf7ebd2$var$Species = (results)=>{
    if (results && results.numFound > 0) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        id: "Species",
        className: "container mb40 anchor",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "fancy-title mb40",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h4", {
                    children: "Species"
                })
            }),
            results.taxonomy.map((doc, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($2fec4872fbf7ebd2$var$Taxon, {
                    taxon: doc
                }, idx))
        ]
    });
};
const $2fec4872fbf7ebd2$var$ResultList = ({ grameneGenes: grameneGenes, grameneDomains: grameneDomains, gramenePathways: gramenePathways, grameneTaxonomy: grameneTaxonomy, searchUI: searchUI, searchUpdated: searchUpdated, doChangeQuantity: doChangeQuantity })=>{
    if (searchUI.Gramene) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        id: "gramene",
        className: "row",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "fancy-title pt50",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h3", {
                    children: "Gramene search results"
                })
            }),
            searchUI.Genes && $2fec4872fbf7ebd2$var$Genes(grameneGenes, searchUI.rows.Genes, doChangeQuantity),
            searchUI.Domains && $2fec4872fbf7ebd2$var$Domains(grameneDomains),
            searchUI.Pathways && $2fec4872fbf7ebd2$var$Pathways(gramenePathways),
            searchUI.Species && $2fec4872fbf7ebd2$var$Species(grameneTaxonomy)
        ]
    });
    else return null;
};
var $2fec4872fbf7ebd2$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)("selectGrameneGenes", "selectGrameneDomains", "selectGramenePathways", "selectGrameneTaxonomy", "selectSearchUI", "selectSearchUpdated", "doChangeQuantity", $2fec4872fbf7ebd2$var$ResultList);





const $27617dbc24e7faf0$var$getStatus = (cat, results, isChecked, toggle)=>{
    const tally = results ? results.numFound : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("img", {
        src: "/static/images/dna_spinner.svg"
    });
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("li", {
        className: "category-leaf",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                type: "checkbox",
                checked: isChecked,
                onChange: (e)=>toggle(cat)
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("a", {
                "data-scroll": true,
                href: `#${cat}`,
                className: "nav-link active",
                children: [
                    cat,
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        style: {
                            float: "right"
                        },
                        children: tally
                    })
                ]
            })
        ]
    });
};
const $27617dbc24e7faf0$var$ResultSummary = ({ grameneGenes: grameneGenes, gramenePathways: gramenePathways, grameneDomains: grameneDomains, grameneTaxonomy: grameneTaxonomy, searchUI: searchUI, searchUpdated: searchUpdated, doToggleCategory: doToggleCategory })=>{
    const status = grameneGenes ? grameneGenes.numFound : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("img", {
        src: "/static/images/dna_spinner.svg"
    });
    if (searchUI.Gramene) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("li", {
        className: "active category-expanded",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("a", {
                onClick: (e)=>doToggleCategory("Gramene"),
                children: [
                    "Gramene Search",
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        style: {
                            float: "right"
                        },
                        children: status
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("ul", {
                className: "list-unstyled",
                children: [
                    $27617dbc24e7faf0$var$getStatus("Genes", grameneGenes, searchUI.Genes, doToggleCategory),
                    $27617dbc24e7faf0$var$getStatus("Domains", grameneDomains, searchUI.Domains, doToggleCategory),
                    $27617dbc24e7faf0$var$getStatus("Pathways", gramenePathways, searchUI.Pathways, doToggleCategory),
                    $27617dbc24e7faf0$var$getStatus("Species", grameneTaxonomy, searchUI.Species, doToggleCategory)
                ]
            })
        ]
    });
    else return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("li", {
        className: "active category-collapsed",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("a", {
            onClick: (e)=>doToggleCategory("Gramene"),
            children: [
                "Gramene Search",
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    style: {
                        float: "right"
                    },
                    children: status
                })
            ]
        })
    });
};
var $27617dbc24e7faf0$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)("selectGrameneGenes", "selectGramenePathways", "selectGrameneDomains", "selectGrameneTaxonomy", "selectSearchUI", "selectSearchUpdated", "doToggleCategory", $27617dbc24e7faf0$var$ResultSummary);








function $541b8b0d8c5501d2$var$showMatches(text, x) {
    let re = new RegExp(`(${x})`, "ig");
    let match = text.split(re);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
        children: match.map((str, idx)=>{
            if (idx % 2 === 1) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                style: {
                    fontWeight: "bolder"
                },
                children: str
            }, idx);
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                children: str
            }, idx);
        })
    });
}
function $541b8b0d8c5501d2$var$logAction(sugg) {
    (0, ($parcel$interopDefault($gXNCa$reactga4))).event({
        category: "Search",
        action: "SetFilter",
        label: sugg.name
    });
}
function $541b8b0d8c5501d2$var$getLowestCommonAncestorName(tids, taxonomy) {
    let lca;
    tids.forEach((tid)=>{
        if (!lca) lca = [
            ...taxonomy[tid].ancestors
        ];
        else {
            let ancestors = new Set(taxonomy[tid].ancestors);
            while(!ancestors.has(lca[0]))lca.shift();
        }
    });
    return taxonomy[lca[0]].short_name;
}
const $541b8b0d8c5501d2$var$Suggestions = (props)=>{
    let suggestions = props.grameneSuggestions;
    if (suggestions && suggestions.grouped) {
        if (suggestions.grouped.category.matches === 0) {
            let sugg1 = {
                fq_field: "text",
                fq_value: props.suggestionsQuery,
                name: `Genes containing "${props.suggestionsQuery}"`,
                category: "Gene"
            };
            let sugg2 = {
                fq_field: "text",
                fq_value: `${props.suggestionsQuery}*`,
                name: `Genes matching "${props.suggestionsQuery}*"`,
                category: "Gene"
            };
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                style: {
                    margin: "10px",
                    maxWidth: "820px"
                },
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Alert), {
                        variant: "info",
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
                                children: "No suggestions found."
                            }),
                            " You may still attempt a full text search, though it is unlikely to find any genes for you."
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Button), {
                        id: "word",
                        size: "sm",
                        variant: "outline-secondary",
                        onClick: ()=>{
                            $541b8b0d8c5501d2$var$logAction(sugg1);
                            props.doAcceptSuggestion(sugg1);
                            props.doAcceptGrameneSuggestion(sugg1);
                        },
                        children: `All genes that contain the word "${props.suggestionsQuery}"`
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Button), {
                        id: "word",
                        size: "sm",
                        variant: "outline-secondary",
                        onClick: ()=>{
                            $541b8b0d8c5501d2$var$logAction(sugg2);
                            props.doAcceptSuggestion(sugg2);
                            props.doAcceptGrameneSuggestion(sugg2);
                        },
                        children: `All genes that contain a word that starts with "${props.suggestionsQuery}"`
                    })
                ]
            });
        } else return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
            style: {
                margin: "10px"
            },
            children: suggestions.grouped.category.groups.map((g, idx)=>{
                return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    id: "gramene-suggestion",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h4", {
                            className: "mt10",
                            children: g.groupValue
                        }),
                        g.doclist.docs.map((sugg, jdx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Button), {
                                id: `${idx}-${jdx}`,
                                disabled: sugg.num_genes === 0,
                                size: "sm",
                                variant: "outline-secondary",
                                onClick: ()=>{
                                    $541b8b0d8c5501d2$var$logAction(sugg);
                                    props.doAcceptSuggestion(sugg);
                                    props.doAcceptGrameneSuggestion(sugg);
                                },
                                children: [
                                    $541b8b0d8c5501d2$var$showMatches(sugg.display_name, props.suggestionsQuery),
                                    " ",
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Badge), {
                                        bg: "secondary",
                                        children: sugg.num_genes
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("i", {
                                        children: [
                                            "\xa0",
                                            $541b8b0d8c5501d2$var$getLowestCommonAncestorName(sugg.taxon_id, props.grameneTaxonomy)
                                        ]
                                    })
                                ]
                            }, jdx))
                    ]
                }, idx);
            })
        });
    } else return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {});
};
var $541b8b0d8c5501d2$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)("selectGrameneSuggestions", "selectSuggestionsQuery", "selectGrameneTaxonomy", "doAcceptSuggestion", "doAcceptGrameneSuggestion", $541b8b0d8c5501d2$var$Suggestions);



















function $9e29a4f60318db7a$var$DynamicIframe(props) {
    // Create a ref for the iframe element
    const iframeRef = (0, $gXNCa$react.useRef)(null);
    // Function to resize iframe height
    const resizeIframe = ()=>{
        if (iframeRef.current) {
            const iframe = iframeRef.current;
            const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
            iframe.style.height = 44 + innerDoc.body.scrollHeight + "px";
        }
    };
    // Resize iframe when content loads
    (0, $gXNCa$react.useEffect)(()=>{
        resizeIframe();
    }, []); // Empty dependency array ensures it only runs once after initial render
    // Optional: Resize iframe when window is resized
    (0, $gXNCa$react.useEffect)(()=>{
        window.addEventListener("resize", resizeIframe);
        return ()=>{
            window.removeEventListener("resize", resizeIframe);
        };
    }, []); // Empty dependency array ensures it only runs once after initial render
    // Resize iframe when content changes
    (0, $gXNCa$react.useEffect)(()=>{
        const iframe = iframeRef.current;
        if (!iframe) return;
        const observer = new MutationObserver(resizeIframe);
        const checkElement = ()=>{
            const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
            const targetElement = innerDoc.querySelector("#heatmapContainer");
            if (targetElement) observer.observe(targetElement, {
                attributes: true,
                childList: true,
                subtree: true
            });
            else setTimeout(checkElement, 200); // Check again after 100 milliseconds
        };
        checkElement();
        return ()=>observer.disconnect();
    }, []);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("iframe", {
        ref: iframeRef,
        src: props.url,
        title: "Dynamic Iframe",
        style: {
            width: "100%",
            border: "none"
        }
    });
}
const $9e29a4f60318db7a$var$Detail = (props)=>{
    const gene = props.geneDocs[props.searchResult.id];
    let paralogs_url;
    let gene_url = `/static/atlasWidget.html?reference=0&genes=${gene.atlas_id || gene._id}`;
    if (props.paralogExpression && props.paralogExpression[gene._id]) {
        let paralogs = props.paralogExpression[gene._id].map((p)=>p.atlas_id || p.id);
        if (paralogs.length > 1) paralogs_url = `/static/atlasWidget.html?reference=1&genes=${paralogs.join(" ")}`;
    } else props.doRequestParalogExpression(gene._id);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Tabs), {
        children: [
            paralogs_url && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Tab), {
                tabClassName: "gxa",
                eventKey: "paralogs",
                title: "Reference Study (all paralogs)",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($9e29a4f60318db7a$var$DynamicIframe, {
                    url: paralogs_url
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Tab), {
                tabClassName: "gxa",
                eventKey: "gene",
                title: "All Studies",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($9e29a4f60318db7a$var$DynamicIframe, {
                    url: gene_url
                })
            }),
            (0, $gXNCa$grameneefpbrowser.haveBAR)(gene) && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Tab), {
                tabClassName: "eFP",
                eventKey: "eFP",
                title: "eFP Browser",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, ($parcel$interopDefault($gXNCa$grameneefpbrowser))), {
                    gene: gene
                })
            })
        ]
    });
};
var $9e29a4f60318db7a$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)("selectParalogExpression", "doRequestParalogExpression", $9e29a4f60318db7a$var$Detail);















const $5c2c79352d3d7b81$export$47eb42ff093406d4 = (props)=>{
    let subComponents = (0, ($parcel$interopDefault($gXNCa$lodashkeyBy)))(props.children, "key");
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "detail",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "intro",
                children: [
                    subComponents.title,
                    subComponents.description
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "content-wrapper",
                children: subComponents.content
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "actions",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        className: "action-wrapper",
                        xs: 12,
                        sm: 5,
                        children: subComponents.explore
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        className: "action-wrapper",
                        xs: 12,
                        sm: 7,
                        children: subComponents.links
                    })
                ]
            })
        ]
    });
};
const $5c2c79352d3d7b81$export$f99233281efd08a0 = (props)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h4", {
        children: props.children
    });
const $5c2c79352d3d7b81$export$393edc798c47379d = (props)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("p", {
        className: "description",
        children: props.children
    });
const $5c2c79352d3d7b81$export$7c6e2c02157bb7d2 = (props)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "content",
        children: props.children
    });
const $5c2c79352d3d7b81$var$QueryTerm = (props)=>{
    let category, name, badge;
    name = props.name;
    if (props.category) category = props.category + " | ";
    if ((0, ($parcel$interopDefault($gXNCa$lodash))).isNumber(props.count)) badge = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Badge), {
        style: {
            marginLeft: "0.5rem"
        },
        bg: "secondary",
        children: props.count
    });
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Button), {
        variant: "outline-dark",
        onClick: props.handleClick,
        children: [
            category,
            name,
            badge
        ]
    });
};
function $5c2c79352d3d7b81$var$renderExplorations(explorations) {
    return explorations.map((exploration, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($5c2c79352d3d7b81$var$QueryTerm, {
            ...exploration
        }, idx));
}
const $5c2c79352d3d7b81$export$900f1bfcd1cb6476 = (props)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "explore",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h5", {
                children: "Search Filters"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                children: $5c2c79352d3d7b81$var$renderExplorations(props.explorations)
            })
        ]
    });
function $5c2c79352d3d7b81$var$renderLinks(links) {
    let external = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("small", {
        title: "This link opens a page from an external site",
        children: [
            " ",
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reacticonsbi.BiLinkExternal), {})
        ]
    });
    return links.map((link, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("li", {
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("a", {
                href: link.url,
                target: "_blank",
                className: "external-link",
                onClick: ()=>{
                    (0, ($parcel$interopDefault($gXNCa$reactga4))).event({
                        category: "outbound link",
                        action: "follow",
                        label: link.name
                    });
                },
                children: [
                    link.name,
                    external
                ]
            })
        }, idx));
}
const $5c2c79352d3d7b81$export$b2e089eb3692b073 = (props)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "links",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h5", {
                children: "Links to other resources"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("ul", {
                children: $5c2c79352d3d7b81$var$renderLinks(props.links)
            })
        ]
    });



const $047461923b1badda$var$firebaseConfig = {
    apiKey: "AIzaSyCyTJmxfWgfuhI6-8uqocSiE9KOWUlkgkk",
    authDomain: "gramene-auth.firebaseapp.com",
    projectId: "gramene-auth",
    storageBucket: "gramene-auth.appspot.com",
    messagingSenderId: "590873346270",
    appId: "1:590873346270:web:f76a31a93619e69439824f"
};
const $047461923b1badda$export$a4e2c8f07e884e = (0, $gXNCa$firebaseapp.initializeApp)($047461923b1badda$var$firebaseConfig);
const $047461923b1badda$export$964d88edb00bbcaa = (suggestion)=>{
    return {
        status: "init",
        rows: 20,
        operation: "AND",
        negate: false,
        leftIdx: 0,
        rightIdx: 3,
        children: [
            {
                fq_field: suggestion.fq_field,
                fq_value: suggestion.fq_value,
                name: suggestion.name,
                category: suggestion.category,
                leftIdx: 1,
                rightIdx: 2,
                negate: false,
                marked: false
            }
        ]
    };
};





class $64fad37f770d2bfe$var$Homology extends (0, ($parcel$interopDefault($gXNCa$react))).Component {
    constructor(props){
        super(props);
        if (!props.geneDocs.hasOwnProperty(props.searchResult.id)) props.requestGene(props.searchResult.id);
        this.taxonomy = (0, ($parcel$interopDefault($gXNCa$gramenetreesclient))).taxonomy.tree(Object.values(props.grameneTaxonomy));
    }
    renderTreeVis() {
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
            className: "gene-genetree",
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, ($parcel$interopDefault($gXNCa$gramenegenetreevis))), {
                genetree: this.tree,
                initialGeneOfInterest: this.gene,
                genomesOfInterest: this.props.grameneGenomes.active,
                taxonomy: this.taxonomy,
                allowGeneSelection: true,
                pivotTree: true,
                enableCuration: false,
                enablePhyloview: true,
                numberOfNeighbors: 10,
                ensemblUrl: this.props.configuration.ensemblURL
            })
        });
    }
    filterAllHomologs() {
        this.props.doReplaceGrameneFilters((0, $047461923b1badda$export$964d88edb00bbcaa)({
            category: "Gene Tree",
            fq_field: "gene_tree",
            fq_value: this.tree._id,
            name: `Homologs of ${this.gene.name}`
        }));
    }
    filterOrthologs() {
        this.props.doReplaceGrameneFilters((0, $047461923b1badda$export$964d88edb00bbcaa)({
            category: "Gene Tree",
            fq_field: "homology__all_orthologs",
            fq_value: this.gene._id,
            name: `Orthologs of ${this.gene.name}`
        }));
    }
    filterParalogs() {
        this.props.doReplaceGrameneFilters((0, $047461923b1badda$export$964d88edb00bbcaa)({
            category: "Gene Tree",
            fq_field: "homology__within_species_paralog",
            fq_value: this.gene._id,
            name: `Paralogs of ${this.gene.name}`
        }));
    }
    orthologList() {
        return this.orthoParaList("ortholog");
    }
    paralogList() {
        return this.orthoParaList("within_species_paralog");
    }
    orthoParaList(type) {
        var homology, thisGeneId;
        homology = (0, ($parcel$interopDefault($gXNCa$lodash))).get(this.gene, "homology.homologous_genes");
        thisGeneId = this.gene._id;
        if (homology) {
            var homologs = (0, ($parcel$interopDefault($gXNCa$lodash)))(homology).pickBy(function filterCategories(thing, name) {
                return name.indexOf(type) === 0;
            }).values().flatten().uniq().value();
            if (!(0, ($parcel$interopDefault($gXNCa$lodash))).isEmpty(homologs)) {
                if (!homologs.includes(thisGeneId)) {
                    console.log("add to homologs list", thisGeneId);
                    homologs.push(thisGeneId);
                }
                return homologs; // only return something if we have something. We're testing for truthiness later.
            }
        }
    }
    explorations() {
        let x = [
            {
                name: "Homologs",
                category: "Gene Tree",
                count: this.tree.geneCount,
                handleClick: this.filterAllHomologs.bind(this)
            }
        ];
        if (this.orthologs) x.push({
            name: "Orthologs",
            category: "Gene Tree",
            count: this.orthologs.length,
            handleClick: this.filterOrthologs.bind(this)
        });
        if (this.paralogs) x.push({
            name: "Paralogs",
            category: "Gene Tree",
            count: this.paralogs.length,
            handleClick: this.filterParalogs.bind(this)
        });
        return x;
    }
    links() {
        let links = [
            {
                name: "Ensembl Gene Tree view",
                url: `${this.props.configuration.ensemblURL}/${this.gene.system_name}/Gene/Compara_Tree?g=${this.gene._id}`
            }
        ];
        if (this.props.curation && this.props.curation.taxa.hasOwnProperty(this.gene.taxon_id)) links.push({
            name: "Curate",
            url: this.props.curation.url + this.gene._id
        });
        return links;
    }
    render() {
        const id = this.props.searchResult.id;
        if (!this.props.geneDocs.hasOwnProperty(id)) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Spinner), {});
        this.gene = this.props.geneDocs[id];
        const treeId = this.gene.homology.gene_tree.id;
        if (!this.props.grameneTrees.hasOwnProperty(treeId)) this.props.doRequestGrameneTree(treeId);
        else {
            const tree = this.props.grameneTrees[treeId];
            if (tree.hasOwnProperty("taxon_id")) {
                this.tree = (0, ($parcel$interopDefault($gXNCa$gramenetreesclient))).genetree.tree([
                    this.props.grameneTrees[treeId]
                ]);
                this.orthologs = this.orthologList();
                this.paralogs = this.paralogList();
            }
        }
        let flagged = 0;
        // if (this.props.curation && this.props.curation.taxa.hasOwnProperty(this.gene.taxon_id)) {
        //   flagged = this.props.curatedGenes && this.props.curatedGenes[id] ? this.props.curatedGenes[id].flagged : 0;
        // }
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $5c2c79352d3d7b81$export$47eb42ff093406d4), {
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $5c2c79352d3d7b81$export$f99233281efd08a0), {
                    children: "Compara Gene Tree"
                }, "title"),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $5c2c79352d3d7b81$export$393edc798c47379d), {
                    children: [
                        "This phylogram shows the relationships between this gene and others similar to it, as determined by Ensembl Compara.",
                        flagged > 1 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Alert), {
                            variant: "warning",
                            children: [
                                "This gene was flagged for potential gene structural annotation issues by ",
                                flagged,
                                " curators"
                            ]
                        })
                    ]
                }, "description"),
                this.tree && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $5c2c79352d3d7b81$export$7c6e2c02157bb7d2), {
                    children: this.renderTreeVis()
                }, "content"),
                this.tree && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $5c2c79352d3d7b81$export$900f1bfcd1cb6476), {
                    explorations: this.explorations()
                }, "explore"),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $5c2c79352d3d7b81$export$b2e089eb3692b073), {
                    links: this.links()
                }, "links")
            ]
        });
    }
}
var $64fad37f770d2bfe$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)("selectGrameneTaxonomy", "selectGrameneTrees", "selectGrameneGenomes", "selectConfiguration", "selectCuration", "selectCuratedGenes", "doRequestGrameneTree", "doAcceptGrameneSuggestion", "doReplaceGrameneFilters", $64fad37f770d2bfe$var$Homology);












// var ensemblREST = require('../../../../../package.json').gramene.ensemblREST;
//const ensemblREST = 'http://data.gramene.org/ensembl63';
// const ensemblREST = 'https://data.sorghumbase.org/ensembl2';
// const ensemblREST = 'https://data.gramene.org/vitis-ensembl1';
// const ensemblREST = 'https://data.gramene.org/pansite-ensembl';
// calculate this once.
const $569586cb7d303e26$var$PREFIX = "/static/gramene-dalliance/";
class $569586cb7d303e26$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($gXNCa$react))).Component {
    constructor(props){
        super(props);
        this.initialVisibleRange = props.visibleRange;
    }
    shouldComponentUpdate(newProps) {
        // should we reset the view to initial state?
        if ((0, ($parcel$interopDefault($gXNCa$lodashisEqual)))(newProps.visibleRange, this.initialVisibleRange)) this.browser.setLocation(newProps.visibleRange.chr, newProps.visibleRange.start, newProps.visibleRange.end);
        return false;
    }
    biodallianceElementId() {
        return this.props.gene._id + "Browser";
    }
    browser() {
        var g, view, start, end, browser;
        g = this.props.gene;
        view = this.props.visibleRange;
        start = view.start;
        end = view.end;
        this.browser = browser = new Browser({
            pageName: this.biodallianceElementId(),
            chr: g.location.region,
            viewStart: start,
            viewEnd: end,
            cookieKey: g._id + "BrowserCookie",
            prefix: $569586cb7d303e26$var$PREFIX,
            coordSystem: {
                speciesName: g.system_name,
                taxon: g.taxon_id,
                auth: "Gramene",
                version: "3",
                ucscName: "IRGSP-1.0"
            },
            sources: [
                {
                    name: "DNA",
                    ensemblURI: this.props.config.ensemblRest,
                    species: g.system_name,
                    tier_type: "sequence"
                },
                {
                    name: "Genes",
                    uri: this.props.config.ensemblRest,
                    tier_type: "ensembl",
                    species: g.system_name,
                    type: [
                        "gene",
                        "transcript",
                        "exon",
                        "cds"
                    ]
                }
            ],
            // hubs: ['/Track_Hubs/DRP000315/hub.txt'],
            disablePoweredBy: true,
            setDocumentTitle: false,
            noDefaultLabels: true,
            noPersist: true,
            noPersistView: true,
            maxWorkers: 2,
            noTitle: true,
            noLocationField: false,
            noLeapButtons: true,
            noZoomSlider: false,
            noTrackAdder: true,
            noTrackEditor: true,
            noExport: true,
            noOptions: true,
            noHelp: true,
            maxViewWidth: 1000000
        });
        browser.addViewListener(this.props.onViewChange);
    }
    cancel() {
        if (typeof this.timeoutID == "number") {
            window.clearTimeout(this.timeoutID);
            delete this.timeoutID;
        }
    }
    componentDidMount() {
        // this.browser();
        this.cancel();
        var self = this;
        this.timeoutID = window.setTimeout(function() {
            self.browser();
        }, 0);
    }
    componentWillUnmount() {
        this.cancel();
    }
    render() {
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
            id: this.biodallianceElementId()
        });
    }
} // DallianceBrowser.propTypes = {
 //   gene: React.PropTypes.object.isRequired,
 //   visibleRange: React.PropTypes.object.isRequired,
 //   expanded: React.PropTypes.bool,
 //   onViewChange: React.PropTypes.func.isRequired
 // };


class $c7afec6772421270$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($gXNCa$react))).Component {
    constructor(props){
        super(props);
    }
    render() {
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
            className: "location-browser",
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $569586cb7d303e26$export$2e2bcd8739ae039), {
                ...this.props,
                expanded: !!this.props.closeModal
            })
        });
    }
} // Browser.propTypes = {
 //   gene: React.PropTypes.object.isRequired,
 //   expanded: React.PropTypes.bool,
 //   visibleRange: React.PropTypes.object.isRequired,
 //   onViewChange: React.PropTypes.func.isRequired
 // };






class $264d7db426cab787$var$Location extends (0, ($parcel$interopDefault($gXNCa$react))).Component {
    constructor(props){
        super(props);
        this.gene = this.props.geneDocs[this.props.searchResult.id];
        this.initRegion();
        this.state = {
            visibleRange: this.initVisibleRange()
        };
    }
    initVisibleRange() {
        var location, span, padding, result;
        location = this.gene.location;
        if (!location) throw new Error(`Could not find the location of the gene in props.`);
        span = location.end - location.start + 1;
        padding = Math.floor(.1 * span);
        result = {
            chr: location.region,
            start: location.start - padding,
            end: location.end + padding
        };
        result.displayName = `${result.chr}:${result.start}-${result.end}`;
        return result;
    }
    initRegion() {
        var region, isChromosome, regionType, regionName;
        region = this.gene.location.region;
        if (region) {
            isChromosome = /^\d+$/.test(region);
            if (isChromosome) {
                regionType = "chromosome";
                regionName = "Chromosome " + region;
            } else {
                regionType = "scaffold";
                regionName = region;
            }
            this.region = {
                isChromsome: isChromosome,
                name: regionName,
                type: regionType
            };
        }
    }
    handleViewChange(chr, start, end) {
        var visibleRange = {
            chr: chr,
            start: start,
            end: end,
            displayName: `${chr}:${start}-${end}`
        };
        if (!(0, ($parcel$interopDefault($gXNCa$lodashisEqual)))(visibleRange, this.state.visibleRange)) this.setState({
            visibleRange: visibleRange
        });
    }
    updateQuery(restrictToVisibleRange) {
        var location, geneName, visibleRange, filter, filterDisplayName, fq;
        location = this.gene.location;
        geneName = this.gene.name;
        // category: 'Gene Tree',
        //   fq_field: 'gene_tree',
        //   fq_value: this.tree._id,
        //   name: `Homologs of ${this.gene.name}`
        let terms = [
            {
                category: "Map",
                name: location.map,
                fq_field: "map",
                fq_value: location.map
            },
            {
                category: "Region",
                name: location.region,
                fq_field: "region",
                fq_value: location.region
            }
        ];
        fq = `map:${location.map} AND region:${location.region}`;
        if (restrictToVisibleRange) {
            visibleRange = this.state.visibleRange;
            terms.push({
                category: "Interval",
                name: `${visibleRange.start}-${visibleRange.end}`,
                fq_field: "start",
                fq_value: `[${visibleRange.start} TO ${visibleRange.end}]`
            });
            fq += ` AND (start:[${visibleRange.start} TO ${visibleRange.end}]` + ` OR end:[${visibleRange.start} TO ${visibleRange.end}])`;
            filterDisplayName = visibleRange.displayName;
        } else filterDisplayName = "Shares " + this.region.type + " with " + geneName;
        console.log("User asked to filter by location");
        filter = {
            category: "Location",
            id: fq,
            fq: fq,
            display_name: filterDisplayName
        };
        // QueryActions.removeAllFilters();
        // QueryActions.setFilter(filter);
        this.props.doAddGrameneRangeQuery(terms);
        if (this.props.closeModal) this.props.closeModal();
    }
    explorations() {
        var visible, result;
        visible = this.state.visibleRange;
        result = [
            {
                name: `All on ${this.region.name}`,
                handleClick: ()=>this.updateQuery(false)
            }
        ];
        if (visible) result.push({
            name: `All within ${(0, ($parcel$interopDefault($gXNCa$lodashget)))(visible, "displayName")}`,
            handleClick: ()=>this.updateQuery(true)
        });
        return result;
    }
    links() {
        function jgiify(id) {
            return id.replace("SORBI_3", "Sobic.").replace(/\.v[0-9]\.[0-9]$/, "");
        }
        var gene = this.gene;
        let links = [
            {
                name: "Ensembl Browser",
                url: `${this.props.config.ensemblURL}/${gene.system_name}/Gene/Summary?g=${gene._id}`
            }
        ];
        if (gene.annotations.taxonomy.ancestors.includes(4557)) links.push({
            name: "Phytozome",
            url: `https://phytozome-next.jgi.doe.gov/report/gene/Sbicolor_v5_1/${jgiify(gene._id)}`
        });
        if (gene.taxon_id === 3702) links.push({
            name: "tair",
            url: `https://www.arabidopsis.org/servlets/TairObject?name=${gene._id}&type=locus`
        }, {
            name: "ThaleMine",
            url: `https://bar.utoronto.ca/thalemine/keywordSearchResults.do?searchTerm=${gene._id}&searchSubmit=search`
        });
        if (gene.taxon_id === 39947) links.push({
            name: "RAP-DB",
            url: `https://rapdb.dna.affrc.go.jp/locus/?name=${gene._id}`
        });
        const isMaize = new RegExp(/^Zm[0-9]+/);
        if (isMaize.test(gene._id)) links.push({
            name: "MaizeGDB",
            url: `http://www.maizegdb.org/gene_center/gene/${gene._id}`
        });
        return links;
    }
    render() {
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $5c2c79352d3d7b81$export$47eb42ff093406d4), {
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $5c2c79352d3d7b81$export$393edc798c47379d), {
                    children: [
                        "Currently viewing: ",
                        this.renderLocation(),
                        "\xa0",
                        this.renderResetButton()
                    ]
                }, "description"),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $5c2c79352d3d7b81$export$7c6e2c02157bb7d2), {
                    children: this.renderBrowser()
                }, "content"),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $5c2c79352d3d7b81$export$900f1bfcd1cb6476), {
                    explorations: this.explorations()
                }, "explore"),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $5c2c79352d3d7b81$export$b2e089eb3692b073), {
                    links: this.links()
                }, "links")
            ]
        });
    }
    renderBrowser() {
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $c7afec6772421270$export$2e2bcd8739ae039), {
            gene: this.gene,
            ...this.props,
            ...this.state,
            onViewChange: this.handleViewChange.bind(this)
        });
    }
    renderGenePosition() {
        var location = this.gene.location;
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
            className: "location",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "region",
                    children: this.region.name
                }),
                ":",
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "start",
                    children: location.start
                }),
                "-",
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "end",
                    children: location.end
                })
            ]
        });
    }
    renderLocation() {
        var location = this.state.visibleRange;
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
            className: "location",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "region",
                    children: location.chr
                }),
                ":",
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "start",
                    children: location.start
                }),
                "-",
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "end",
                    children: location.end
                })
            ]
        });
    }
    resetVisibleRange() {
        const { chr: chr, start: start, end: end } = this.initVisibleRange();
        this.handleViewChange(chr, start, end);
    }
    renderResetButton() {
        // let active=isEqual(this.props.visibleRange, this.state.visibleRange);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Button), {
            size: "sm",
            variant: "outline-dark",
            onClick: ()=>this.resetVisibleRange(),
            children: "Reset"
        });
    }
}
var $264d7db426cab787$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)("doAddGrameneRangeQuery", $264d7db426cab787$var$Location);













var $54c74a4689d5a778$var$reactomeURL = "https://plantreactome.gramene.org";
class $54c74a4689d5a778$var$Pathways extends (0, ($parcel$interopDefault($gXNCa$react))).Component {
    constructor(props){
        super(props);
        this.taxonomy = (0, ($parcel$interopDefault($gXNCa$gramenetreesclient))).taxonomy.tree(Object.values(props.grameneTaxonomy));
        this.gene = props.geneDocs[props.searchResult.id];
        this.holderId = "displayHolder" + this.gene._id;
        this.state = {};
    }
    initDiagram() {
        this.diagram = Reactome.Diagram.create({
            proxyPrefix: $54c74a4689d5a778$var$reactomeURL,
            placeHolder: this.holderId,
            width: this.divWrapper.clientWidth - 350 - 1,
            height: 500
        });
    }
    stableId(dbId) {
        let prefix = this.taxonomy.indices.id[this.gene.taxon_id].model.reactomePrefix || "OSA";
        return `R-${prefix}-${dbId}`;
    }
    loadDiagram(pathwayId, reactionId) {
        if (!this.diagram) this.initDiagram();
        this.diagram.loadDiagram(pathwayId);
        this.diagram.onDiagramLoaded((function(loaded) {
            this.loadedDiagram = loaded;
            if (reactionId) this.diagram.selectItem(reactionId);
            // var xref = _.find(this.props.gene.xrefs,{db : 'Gramene_Plant_Reactome'}).ids[0];
            this.diagram.flagItems(this.gene._id);
        }).bind(this));
    }
    componentDidMount() {
        if (Reactome && Reactome.Diagram) ;
        else window.addEventListener("launchDiagram", (function(e) {
        // this.initDiagram()
        }).bind(this));
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.hierarchy && !this.state.selectedNode) {
            let node = this.state.hierarchy[0];
            let path = [
                0
            ];
            let parent = node;
            while(node.nodes){
                path.push(0);
                parent = node;
                node = node.nodes[0];
            }
            console.log(parent, node, path);
            this.loadNodes(path);
        }
        if (!this.state.hierarchy && this.pathwayIds) {
            const haveDocs = this.pathwayIds.filter((id)=>this.props.gramenePathways.hasOwnProperty(id));
            if (haveDocs.length === this.pathwayIds.length) {
                const docs = this.pathwayIds.map((id)=>this.props.gramenePathways[id]);
                this.getHierarchy(this.makeTaxonSpecific(docs, this.gene.taxon_id));
            }
        }
    }
    componentWillMount() {
        var pathways, reactionId, ancestorIds;
        pathways = this.gene.annotations.pathways;
        if (!pathways) throw new Error("No pathway annotation present for " + this.gene._id);
        this.pathwayIds = (0, ($parcel$interopDefault($gXNCa$lodash))).clone(pathways.ancestors);
        pathways.entries.forEach((function(reaction) {
            let [r, speciesCode, id] = reaction.id.split("-");
            this.pathwayIds.push(+id);
        }).bind(this));
        this.props.doRequestGramenePathways(this.pathwayIds);
    // DocActions.needDocs('pathways', this.pathwayIds, (docs) => { return this.makeTaxonSpecific(docs,this.props.gene.taxon_id)}, this.getHierarchy);
    }
    makeTaxonSpecific(docs, taxon_id) {
        let lineageField = "lineage_" + taxon_id;
        if (!docs[0].hasOwnProperty(lineageField)) {
            let tid = Math.floor(taxon_id / 1000);
            lineageField = "lineage_" + tid;
        }
        let tsDocs = docs.map(function(doc) {
            let tsDoc = (0, ($parcel$interopDefault($gXNCa$lodash))).pick(doc, [
                "_id",
                "name",
                "type"
            ]);
            tsDoc.lineage = doc[lineageField];
            return tsDoc;
        });
        console.log(tsDocs);
        return tsDocs;
    }
    componentWillUnmount() {
        // DocActions.noLongerNeedDocs('pathways', this.pathwayIds);
        if (this.diagram) this.diagram.detach();
    }
    getHierarchy(docs) {
        let pathways = (0, ($parcel$interopDefault($gXNCa$lodash))).keyBy(docs, "_id");
        let nodes = [];
        this.pathwayIds.forEach(function(pwyId) {
            if (pathways[pwyId]) {
                let pwy = pathways[pwyId];
                pwy.lineage.forEach(function(line) {
                    let parentOffset = line.length - 2;
                    nodes.push({
                        id: pwyId,
                        key: pwyId,
                        label: pwy.name,
                        type: pwy.type,
                        checkbox: false,
                        selected: false,
                        parent: parentOffset >= 0 ? line[parentOffset] : undefined
                    });
                });
            }
        });
        let nested = new (0, ($parcel$interopDefault($gXNCa$flattonested)))({
            children: "nodes"
        }).convert(nodes);
        this.setState({
            hierarchy: [
                nested
            ],
            selectedNode: undefined
        });
    }
    possiblyLoadNodes(node) {
        if (!node.selected) {
            let selectedNode = this.state.selectedNode;
            selectedNode.selected = false;
            node.selected = true;
            selectedNode = node;
            if (node.type === "Pathway") {
                let pathway = this.stableId(node.id);
                this.loadDiagram(pathway);
            } else {
                let reaction = this.stableId(node.id);
                let pathway = this.stableId(node.parent.split("/").pop());
                if (this.loadedDiagram === pathway) this.diagram.selectItem(reaction);
                else {
                    if (this.diagram) this.diagram.resetSelection();
                    this.loadDiagram(pathway, reaction);
                }
            }
            this.setState({
                selectedNode: selectedNode
            });
        }
    }
    loadNodes(nodes) {
        let hierarchy = this.state.hierarchy;
        let selectedNode = this.state.selectedNode;
        let offset = nodes.shift();
        let nodeRef = hierarchy[offset];
        let lineage = [
            nodeRef
        ];
        while(nodeRef.nodes){
            nodeRef = nodeRef.nodes[0];
            lineage.unshift(nodeRef);
        }
        if (lineage[0].id !== 2894885) {
            let pathway = this.stableId(lineage[0].id);
            let reaction = undefined;
            if (lineage[0].type === "Reaction") {
                reaction = pathway;
                pathway = this.stableId(lineage[1].id);
            }
            if (lineage[0].selected) {
                selectedNode = undefined;
                lineage[0].selected = false;
                if (this.loadedDiagram === pathway) this.diagram.resetSelection();
                else {
                    if (this.diagram) this.diagram.resetSelection();
                    this.loadDiagram(pathway);
                }
            } else {
                if (selectedNode) selectedNode.selected = false;
                selectedNode = lineage[0];
                lineage[0].selected = true;
                if (this.loadedDiagram === pathway) {
                    if (reaction) this.diagram.selectItem(reaction);
                    else this.diagram.resetSelection();
                } else {
                    if (this.diagram) this.diagram.resetSelection();
                    if (reaction) this.loadDiagram(pathway, reaction);
                    else this.loadDiagram(pathway);
                }
            }
            this.setState({
                hierarchy: hierarchy,
                selectedNode: selectedNode
            });
        }
    }
    renderHierarchy() {
        if (this.state.hierarchy) {
            let path = [];
            let allPaths = [];
            let nodes = this.state.hierarchy;
            while(nodes){
                path.push(nodes[0].key);
                allPaths.push(path.join("/"));
                if (nodes[0].hasOwnProperty("nodes")) nodes = nodes[0].nodes;
                else nodes = undefined;
            }
            // console.log(path);
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, ($parcel$interopDefault($gXNCa$reactsimpletreemenu))), {
                data: this.state.hierarchy,
                hasSearch: false,
                onClickItem: (item)=>this.possiblyLoadNodes(item),
                onClickItemx: (item)=>console.log("onClickItem", item),
                initialActiveKey: path.join("/"),
                initialOpenNodes: allPaths
            });
        // return (
        //   <TreeMenu
        //     data={this.state.hierarchy}
        //     expandIconClass="fa fa-chevron-right"
        //     collapseIconClass="fa fa-chevron-down"
        //     stateful={true}
        //     collapsible={true}
        //     onTreeNodeClick={this.loadNodes.bind(this)}
        //   />
        // );
        }
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Spinner), {});
    }
    updateQuery() {
        console.log("User asked to filter by " + this.state.selectedNode.type);
        this.props.doAcceptGrameneSuggestion({
            category: "Plant Reactome",
            fq_field: "pathways__ancestors",
            fq_value: this.state.selectedNode.id,
            name: this.state.selectedNode.label
        });
    }
    render() {
        let reactomeLink, searchFilter;
        if (this.state.selectedNode) {
            let xrefLUT = (0, ($parcel$interopDefault($gXNCa$lodash))).keyBy(this.gene.xrefs, "db");
            let links = [
                {
                    name: "Plant Reactome " + this.state.selectedNode.type,
                    url: `${$54c74a4689d5a778$var$reactomeURL}/content/detail/${this.stableId(this.state.selectedNode.id)}`
                }
            ];
            if (xrefLUT.hasOwnProperty("notGramene_Plant_Reactome")) links.push({
                name: "Plant Reactome Gene",
                url: `${$54c74a4689d5a778$var$reactomeURL}/content/detail/${xrefLUT.notGramene_Plant_Reactome.ids[0]}`
            });
            reactomeLink = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $5c2c79352d3d7b81$export$b2e089eb3692b073), {
                links: links
            }, "links");
            let filters = [
                {
                    name: `All genes in this ${this.state.selectedNode.type}`,
                    handleClick: ()=>this.updateQuery()
                }
            ];
            searchFilter = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $5c2c79352d3d7b81$export$900f1bfcd1cb6476), {
                explorations: filters
            }, "explore");
        }
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            ref: (div)=>{
                this.divWrapper = div;
            },
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                    style: {
                        width: 350,
                        height: 500,
                        overflow: "scroll",
                        float: "left"
                    },
                    children: this.renderHierarchy()
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                    id: this.holderId
                }),
                searchFilter,
                reactomeLink
            ]
        });
    }
}
var $54c74a4689d5a778$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)("selectGrameneTaxonomy", "selectGramenePathways", "doRequestGramenePathways", "doAcceptGrameneSuggestion", $54c74a4689d5a778$var$Pathways);












const $283508ffcf8a47c4$var$ggURL = {
    IRRI: "https://gringlobal.irri.org/gringlobal/accessiondetail?id=",
    ARS: "https://npgsweb.ars-grin.gov/gringlobal/accessiondetail.aspx?id=",
    ICRISAT: "https://genebank.icrisat.org/IND/PassportSummary?ID=",
    sorbmutdb: "https://www.depts.ttu.edu/igcast/sorbmutdb.php"
};
const $283508ffcf8a47c4$var$rice_studies = {
    "1": {
        label: "Rice 3K",
        type: "NAT"
    }
};
const $283508ffcf8a47c4$var$study_info = {
    "sorghum_bicolor": {
        "1": {
            label: "Purdue EMS",
            type: "EMS"
        },
        "2": {
            label: "USDA Lubbock EMS",
            type: "EMS"
        },
        "3": {
            label: "Lozano",
            type: "NAT"
        },
        "4": {
            label: "USDA Lubbock EMS",
            type: "EMS"
        },
        "5": {
            label: "Boatwright SAP",
            type: "NAT"
        },
        "7": {
            label: "Kumar BAP",
            type: "NAT"
        },
        "8": {
            label: "Lasky landraces",
            type: "NAT"
        },
        "9": {
            label: "Sorghum Genomics Toolbox",
            type: "NAT"
        }
    },
    "oryza_sativa": {
        "7": {
            label: "Rice 3K",
            type: "NAT"
        },
        "29": {
            label: "Rice USDA mini core",
            type: "NAT"
        },
        "38": {
            label: "RAPDB 2024",
            type: "NAT"
        }
    },
    "oryza_aus": $283508ffcf8a47c4$var$rice_studies,
    "oryza_sativa117425": $283508ffcf8a47c4$var$rice_studies,
    "oryza_sativa125827": $283508ffcf8a47c4$var$rice_studies,
    "oryza_sativaazucena": $283508ffcf8a47c4$var$rice_studies,
    "oryza_sativair64": $283508ffcf8a47c4$var$rice_studies,
    "oryza_sativamh63": $283508ffcf8a47c4$var$rice_studies,
    "oryza_sativazs97": $283508ffcf8a47c4$var$rice_studies
};
const $283508ffcf8a47c4$var$AccessionLink = ({ germplasm: germplasm, gene_id: gene_id })=>{
    const genebank = germplasm.stock_center;
    const url = $283508ffcf8a47c4$var$ggURL[genebank];
    if (germplasm.germplasm_dbid) {
        const germ_id = germplasm.germplasm_dbid;
        if (germ_id && url && germ_id !== "0") return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("a", {
            target: "_blank",
            href: `${url}${germ_id}`,
            children: [
                germplasm.pub_id,
                " (",
                genebank,
                ")"
            ]
        });
    }
    if (genebank === "sorbmutdb") return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("form", {
        id: germplasm.pub_id,
        action: url,
        method: "post",
        target: "_blank",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                type: "hidden",
                name: "search",
                value: gene_id.replace("SORBI_3", "Sobic.")
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                type: "hidden",
                name: "submit",
                value: "Search"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                type: "submit",
                className: "button-like-link",
                children: "SorbMutDB"
            })
        ]
    });
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
        children: germplasm.pub_id
    });
};
function $283508ffcf8a47c4$var$group_germplasm(gene, germplasmLUT, vep_obj) {
    let accessionTable = [];
    Object.entries(vep_obj).forEach(([key, accessions])=>{
        const parts = key.split("__");
        if (parts[0] === "VEP") {
            if (parts[1] !== "merged") accessions.filter((ens_id)=>germplasmLUT.hasOwnProperty(ens_id)).forEach((ens_id)=>{
                const germplasm = germplasmLUT[ens_id][0];
                const pop = $283508ffcf8a47c4$var$study_info[parts[3]][parts[4]];
                const conseq = parts[1].replaceAll("_", " ");
                const status = parts[2] === "het" ? "heterozygous" : "homozygous";
                const accInfo = {
                    key: [
                        pop.label,
                        conseq,
                        status
                    ].join("%%%"),
                    germplasm: germplasm,
                    pop: pop
                };
                accessionTable.push(accInfo);
            });
        }
    });
    // group accessionTable by key field
    const groups = (0, ($parcel$interopDefault($gXNCa$lodash))).groupBy(accessionTable, "key");
    let grouped = [];
    let id = 0;
    Object.keys(groups).sort().forEach((group)=>{
        const [pop, conseq, status] = group.split("%%%");
        id++;
        const tally = groups[group].length;
        grouped.push({
            id: id,
            group: group,
            summary: true,
            pop: pop,
            conseq: conseq,
            status: status,
            tally: tally
        });
        groups[group].forEach((acc)=>{
            id++;
            grouped.push({
                id: id,
                group: group,
                summary: false,
                pop: pop,
                conseq: conseq,
                status: status,
                accession: acc,
                tally: tally
            });
        });
    });
    return grouped;
}
const $283508ffcf8a47c4$var$THRESHOLD = 5;
const $283508ffcf8a47c4$var$GridWithGroups = ({ groups: groups, gene_id: gene_id })=>{
    const [rowData, setRowData] = (0, $gXNCa$react.useState)(groups);
    const initialExpanded = {};
    rowData.forEach((row)=>{
        if (row.summary) initialExpanded[row.group] = row.tally < $283508ffcf8a47c4$var$THRESHOLD;
    });
    const [expandedGroups, setExpandedGroups] = (0, $gXNCa$react.useState)(initialExpanded);
    // Toggle group visibility
    const toggleGroup = (group)=>{
        setExpandedGroups((prevExpandedGroups)=>({
                ...prevExpandedGroups,
                [group]: !prevExpandedGroups[group]
            }));
    };
    // Filter the data to show/hide rows based on the expanded group state
    const getVisibleRowData = ()=>{
        const visibleRows = [];
        rowData.forEach((row)=>{
            if (row.summary) {
                if (row.tally > 1) visibleRows.push(row);
            } else if (expandedGroups[row.group]) visibleRows.push(row); // Show non-summary rows if the group is expanded
        });
        return visibleRows;
    };
    // Define columns with a custom renderer for the summary rows
    const columnDefs = [
        {
            field: "pop",
            headerName: "Study/Population",
            flex: 1,
            cellRenderer: (params)=>{
                if (params.data.summary || params.data.tally === 1) return params.value;
                return null;
            }
        },
        {
            field: "conseq",
            headerName: "VEP consequence",
            flex: 1,
            cellRenderer: (params)=>{
                if (params.data.summary || params.data.tally === 1) return params.value;
                return null;
            }
        },
        {
            field: "status",
            headerName: "Allele status",
            flex: 1,
            cellRenderer: (params)=>{
                if (params.data.summary || params.data.tally === 1) return params.value;
                return null;
            }
        },
        {
            field: "accession",
            headerName: "Order Germplasm",
            flex: 1,
            headerComponent: (props)=>{
                return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    style: {
                        display: "flex",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
                            className: "fas fa-shopping-cart"
                        }),
                        "\xa0",
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                            children: props.displayName
                        })
                    ]
                });
            },
            cellRenderer: (params)=>{
                if (params.value) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($283508ffcf8a47c4$var$AccessionLink, {
                    germplasm: params.value.germplasm,
                    gene_id: gene_id
                });
                if (params.data.summary) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                    onClick: ()=>toggleGroup(params.data.group),
                    children: [
                        params.data.tally,
                        " Accessions ",
                        expandedGroups[params.data.group] ? "\u25BC" : "\u25B6"
                    ]
                });
                return null;
            }
        },
        {
            field: "synonym",
            headerName: "Synonym",
            filter: false,
            sortable: false,
            flex: 1,
            cellRenderer: (params)=>{
                console.log(params.data);
                if (params.data.accession) return params.data.accession.germplasm.ens_id;
                return null;
            }
        },
        {
            field: "search",
            headerName: "All LOF Genes",
            sortable: false,
            filter: false,
            flex: 1,
            cellRenderer: (params)=>{
                if (params.data.accession) {
                    const currentURL = new URL(window.location.href);
                    const accession = params.data.accession;
                    currentURL.search = "";
                    currentURL.searchParams.set("category", "Germplasm");
                    currentURL.searchParams.set("fq_field", `VEP__merged__${accession.pop.type}__attr_ss`);
                    currentURL.searchParams.set("fq_value", accession.germplasm.ens_id);
                    currentURL.searchParams.set("name", accession.germplasm.ens_id);
                    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Button), {
                        size: "sm",
                        href: currentURL.toString(),
                        children: "Search"
                    });
                }
                return null;
            }
        }
    ];
    const defaultColDef = {
        sortable: true,
        filter: "agTextColumnFilter",
        cellStyle: (params)=>{
            if (params.data.summary) return {
                cursor: "pointer"
            };
            return null;
        }
    };
    const nVisible = getVisibleRowData().length;
    const tableHeight = 50 + Math.min(nVisible, 10) * 42;
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "ag-theme-quartz",
        style: {
            height: tableHeight,
            width: "100%",
            maxWidth: "1200px"
        },
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$aggridreact.AgGridReact), {
            rowData: getVisibleRowData(),
            columnDefs: columnDefs,
            getRowNodeId: (data)=>data.id,
            animateRows: true,
            defaultColDef: defaultColDef
        })
    });
};
const $283508ffcf8a47c4$var$Detail = (props)=>{
    const gene = props.geneDocs[props.searchResult.id];
    if (props.grameneConsequences && props.grameneConsequences[gene._id] && props.grameneGermplasm) {
        const groups = $283508ffcf8a47c4$var$group_germplasm(gene, props.grameneGermplasm, props.grameneConsequences[gene._id]);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h5", {
                    children: "Predicted loss-of-function alleles were detected in these germplasm."
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    children: [
                        "Explore other variants within this gene in the ",
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("a", {
                            target: "_blank",
                            href: `${props.configuration.ensemblURL}/${gene.system_name}/Gene/Variation_Gene/Image?db=core;g=${props.searchResult.id}`,
                            children: "Variant image"
                        }),
                        " page in the Ensembl genome browser."
                    ]
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($283508ffcf8a47c4$var$GridWithGroups, {
                    groups: groups,
                    gene_id: gene._id
                })
            ]
        });
    } else {
        props.doRequestVEP(gene._id);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("pre", {
            children: "loading"
        });
    }
};
var $283508ffcf8a47c4$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)("selectConfiguration", "selectGrameneConsequences", "selectGrameneGermplasm", "doRequestVEP", $283508ffcf8a47c4$var$Detail);








const $b7cae39a716ca5a8$var$HOW_MANY_TO_SHOW_BY_DEFAULT = 10;
class $b7cae39a716ca5a8$var$Xref extends (0, ($parcel$interopDefault($gXNCa$react))).Component {
    constructor(props){
        super(props);
        this.state = {
            showAll: false
        };
    }
    toggleShowAll() {
        this.setState({
            showAll: !this.state.showAll
        });
    }
    possiblyTruncateList(vals) {
        var ellipsis, ellipsisChar, ellipsisTitle;
        if (vals.length > $b7cae39a716ca5a8$var$HOW_MANY_TO_SHOW_BY_DEFAULT) {
            if (this.state.showAll) {
                ellipsisChar = "^ show first " + $b7cae39a716ca5a8$var$HOW_MANY_TO_SHOW_BY_DEFAULT;
                ellipsisTitle = "Show less";
            } else {
                ellipsisChar = "\u2026 show all (" + (vals.length - $b7cae39a716ca5a8$var$HOW_MANY_TO_SHOW_BY_DEFAULT) + " more)";
                ellipsisTitle = "Show more";
                vals = vals.slice(0, $b7cae39a716ca5a8$var$HOW_MANY_TO_SHOW_BY_DEFAULT);
            }
            ellipsis = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("li", {
                className: "showAll",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("a", {
                    title: ellipsisTitle,
                    onClick: this.toggleShowAll.bind(this),
                    children: ellipsisChar
                })
            }, "showMore");
            vals.push(ellipsis);
        }
        return vals;
    }
    render() {
        var db = this.props.xref.label;
        var urlfcn = this.props.xref.url;
        var members = this.props.members.sort();
        var vals = members.map(function(item, idx) {
            var url = urlfcn(item), liClass = idx < $b7cae39a716ca5a8$var$HOW_MANY_TO_SHOW_BY_DEFAULT ? "default" : "extra";
            let external = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("small", {
                title: "This link opens a page from an external site",
                children: [
                    " ",
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
                        className: "fa fa-external-link"
                    })
                ]
            });
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("li", {
                className: liClass,
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("a", {
                    href: url,
                    target: "_blank",
                    onClick: ()=>{
                        (0, ($parcel$interopDefault($gXNCa$reactga4))).event({
                            category: "outbound link",
                            action: "follow",
                            label: item
                        });
                    },
                    children: [
                        item,
                        external
                    ]
                })
            }, idx);
        });
        vals = this.possiblyTruncateList(vals);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                    className: "xref-name-col",
                    children: db
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                    className: "xref-value-col",
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("ol", {
                        className: "xref-id-list",
                        children: vals
                    })
                })
            ]
        });
    }
}
function $b7cae39a716ca5a8$var$formatXrefsForGene(gene) {
    if (!gene || !(0, ($parcel$interopDefault($gXNCa$lodash))).isArray(gene.xrefs)) throw new Error("No xrefs for " + (0, ($parcel$interopDefault($gXNCa$lodash))).get(gene._id));
    return gene.xrefs.filter((xr)=>(0, ($parcel$interopDefault($gXNCa$gramenedbxrefs))).isKnown(xr.db) && xr.db !== "PUBMED").sort().map((xr, idx)=>{
        var xref = (0, ($parcel$interopDefault($gXNCa$gramenedbxrefs))).fetch(xr.db);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($b7cae39a716ca5a8$var$Xref, {
            xref: xref,
            members: xr.ids,
            source: xr.source,
            text: xr.text
        }, idx);
    });
}
const $b7cae39a716ca5a8$var$Xrefs = ({ searchResult: searchResult, geneDocs: geneDocs })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $5c2c79352d3d7b81$export$47eb42ff093406d4), {
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $5c2c79352d3d7b81$export$f99233281efd08a0), {
                children: "Cross-references"
            }, "title"),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $5c2c79352d3d7b81$export$393edc798c47379d), {
                children: "References to this gene in other databases:"
            }, "description"),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $5c2c79352d3d7b81$export$7c6e2c02157bb7d2), {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("table", {
                    className: "xrefs table",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("th", {
                                        className: "xref-name-col",
                                        children: "Database"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("th", {
                                        className: "xref-value-col",
                                        children: "IDs and links"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("tbody", {
                            children: $b7cae39a716ca5a8$var$formatXrefsForGene(geneDocs[searchResult.id])
                        })
                    ]
                })
            }, "content")
        ]
    });
var $b7cae39a716ca5a8$export$2e2bcd8739ae039 = $b7cae39a716ca5a8$var$Xrefs;








const $830f925242a0b007$var$HOW_MANY_TO_SHOW_BY_DEFAULT = 10;
class $830f925242a0b007$var$Xref extends (0, ($parcel$interopDefault($gXNCa$react))).Component {
    constructor(props){
        super(props);
        this.state = {
            showAll: false
        };
    }
    toggleShowAll() {
        this.setState({
            showAll: !this.state.showAll
        });
    }
    possiblyTruncateList(vals) {
        var ellipsis, ellipsisChar, ellipsisTitle;
        if (vals.length > $830f925242a0b007$var$HOW_MANY_TO_SHOW_BY_DEFAULT) {
            if (this.state.showAll) {
                ellipsisChar = "^ show first " + $830f925242a0b007$var$HOW_MANY_TO_SHOW_BY_DEFAULT;
                ellipsisTitle = "Show less";
            } else {
                ellipsisChar = "\u2026 show all (" + (vals.length - $830f925242a0b007$var$HOW_MANY_TO_SHOW_BY_DEFAULT) + " more)";
                ellipsisTitle = "Show more";
                vals = vals.slice(0, $830f925242a0b007$var$HOW_MANY_TO_SHOW_BY_DEFAULT);
            }
            ellipsis = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("li", {
                className: "showAll",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("a", {
                    title: ellipsisTitle,
                    onClick: this.toggleShowAll.bind(this),
                    children: ellipsisChar
                })
            }, "showMore");
            vals.push(ellipsis);
        }
        return vals;
    }
    render() {
        var db = this.props.xref.label;
        var urlfcn = this.props.xref.url;
        var members = this.props.members.sort();
        var vals = members.map(function(item, idx) {
            var url = urlfcn(item), liClass = idx < $830f925242a0b007$var$HOW_MANY_TO_SHOW_BY_DEFAULT ? "default" : "extra";
            let external = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("small", {
                title: "This link opens a page from an external site",
                children: [
                    " ",
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
                        className: "fa fa-external-link"
                    })
                ]
            });
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("li", {
                className: liClass,
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("a", {
                    href: url,
                    target: "_blank",
                    onClick: ()=>{
                        (0, ($parcel$interopDefault($gXNCa$reactga4))).event({
                            category: "outbound link",
                            action: "follow",
                            label: item
                        });
                    },
                    children: [
                        item,
                        external
                    ]
                })
            }, idx);
        });
        vals = this.possiblyTruncateList(vals);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                    className: "xref-value-col",
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("ol", {
                        className: "xref-id-list",
                        children: vals
                    })
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                    className: "xref-name-col",
                    children: this.props.source
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                    className: "xref-value-col",
                    children: this.props.text
                })
            ]
        });
    }
}
function $830f925242a0b007$var$formatPubsForGene(gene) {
    if (!gene || !(0, ($parcel$interopDefault($gXNCa$lodash))).isArray(gene.xrefs)) throw new Error("No xrefs for " + (0, ($parcel$interopDefault($gXNCa$lodash))).get(gene._id));
    let pubs = gene.xrefs.filter((xr)=>xr.db === "PUBMED");
    if (pubs.length === 0) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("tr", {
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
            colSpan: 3,
            children: "No publications found."
        })
    });
    return pubs.sort((a, b)=>{
        if (a.source) {
            if (b.source) {
                if (a.source < b.source) return -1;
                if (a.source > b.source) return 1;
            } else return -1;
        } else if (b.source) return 1;
        if (a.db < b.db) return -1;
        if (a.db > b.db) return 1;
        return 0;
    }).map((xr, idx)=>{
        var xref = (0, ($parcel$interopDefault($gXNCa$gramenedbxrefs))).fetch(xr.db);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($830f925242a0b007$var$Xref, {
            xref: xref,
            members: xr.ids,
            source: xr.source,
            text: xr.text
        }, idx);
    });
}
const $830f925242a0b007$var$formURL = "https://docs.google.com/forms/d/e/1FAIpQLSey-xPyTysdd9c2phXT6kcbjEDeCppG4dLG7LjZCeLpx_KGog/viewform?usp=pp_url&entry.1266455249=";
const $830f925242a0b007$var$Publications = ({ searchResult: searchResult, geneDocs: geneDocs })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $5c2c79352d3d7b81$export$47eb42ff093406d4), {
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $5c2c79352d3d7b81$export$f99233281efd08a0), {
                children: "Curated publications"
            }, "title"),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $5c2c79352d3d7b81$export$393edc798c47379d), {
                children: "Functions described in the literature:"
            }, "description"),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $5c2c79352d3d7b81$export$7c6e2c02157bb7d2), {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("table", {
                    className: "xrefs table",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("th", {
                                        className: "xref-10-col",
                                        children: "PubMed link"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("th", {
                                        className: "xref-10-col",
                                        children: "Curation source"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("th", {
                                        className: "xref-80-col",
                                        children: "Title/Description"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("tbody", {
                            children: $830f925242a0b007$var$formatPubsForGene(geneDocs[searchResult.id])
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("tfoot", {
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("th", {
                                    colSpan: 3,
                                    children: [
                                        "Submit a gene function ",
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("a", {
                                            target: "_blank",
                                            href: $830f925242a0b007$var$formURL + searchResult.id,
                                            children: "here"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }, "content")
        ]
    });
var $830f925242a0b007$export$2e2bcd8739ae039 = $830f925242a0b007$var$Publications;









const $527ebc19dc92444d$var$CodeBlock = (props)=>{
    const plainFasta = `>${props.id}\n${props.seq}`;
    const [showNotification, setShowNotification] = (0, $gXNCa$react.useState)(false);
    const copyCode = ()=>{
        // Use the Clipboard API to write text to the clipboard
        navigator.clipboard.writeText(plainFasta).then(()=>{
            setShowNotification(true);
        }).catch((err)=>{
            console.error("Unable to copy to clipboard", err);
        });
    };
    (0, $gXNCa$react.useEffect)(()=>{
        if (showNotification) {
            const notificationTimeout = setTimeout(()=>{
                setShowNotification(false);
            }, 2000); // Hide the notification after 2 seconds
            return ()=>clearTimeout(notificationTimeout);
        }
    }, [
        showNotification
    ]);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "fasta-container",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("code", {
                className: "fasta",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                        className: "header",
                        children: [
                            ">",
                            props.id
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                    props.blocks.map((block, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                            className: block.kind,
                            children: block.seq
                        }, idx))
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("p", {
                className: "fasta-key",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                        children: "Key:"
                    }),
                    "\xa05'UTR\xa0",
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: "square-utr5",
                        children: "\xa0\xa0"
                    }),
                    "\xa0CDS\xa0",
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: "square-cds",
                        children: "\xa0\xa0"
                    }),
                    "\xa03'UTR\xa0",
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: "square-utr3",
                        children: "\xa0\xa0"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                className: "copy-button",
                onClick: copyCode,
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reacticonsai.AiOutlineCopy), {})
            }),
            showNotification && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "notification",
                children: "Sequence copied"
            })
        ]
    });
};
const $527ebc19dc92444d$var$decoratePeptide = (seq, transcript)=>{
    let junctions = [];
    if (transcript.exon_junctions) transcript.exon_junctions.forEach((ej, idx)=>{
        if (ej > transcript.cds.start && ej <= transcript.cds.end) junctions.push(Math.floor((ej - transcript.cds.start) / 3));
    });
    if (junctions.length === 0) return [
        {
            kind: "cds",
            seq: seq
        }
    ];
    let offset = 0;
    let blocks = [];
    junctions.forEach((j, idx)=>{
        let kind = idx % 2 === 0 ? "cds" : "cds-other";
        blocks.push({
            kind: kind,
            seq: seq.substring(offset, j)
        });
        offset = j;
    });
    blocks.push({
        kind: junctions.length % 2 === 0 ? "cds" : "cds-other",
        seq: seq.substring(junctions.pop())
    });
    return blocks;
};
const $527ebc19dc92444d$var$decorateSeq = (geneSeq, gene, up, down, tid, mode)=>{
    // return a list of blocks with kind and seq properties
    let blocks = [];
    const transcript = gene.gene_structure.transcripts.find((tr)=>tr.id === tid);
    const offset = gene.location.strand === 1 ? gene.location.start - geneSeq.start : geneSeq.end - gene.location.end;
    if (up > 0) {
        const TSS = gene.gene_structure.exons.find((exon)=>exon.id === transcript.exons[0]).start;
        blocks.push({
            kind: "upstream",
            seq: geneSeq.seq.substring(offset - up + TSS - 1, offset + TSS - 1).toLowerCase()
        });
    }
    // add exons and introns based on tid
    let pos_in_transcript = 0;
    let pos_in_gene = 0;
    let blockType = "utr5";
    let extra = "";
    transcript.exons.forEach((eid, e_idx)=>{
        const exon = gene.gene_structure.exons.find((exon)=>exon.id === eid);
        if (e_idx > 0 && mode === "dna") {
            blocks.push({
                kind: "intron",
                seq: geneSeq.seq.substring(offset + pos_in_gene, offset + exon.start - 1).toLowerCase()
            });
            pos_in_gene = exon.start - 1;
        }
        if (mode === "rna") extra = e_idx % 2 === 1 ? "-other" : "";
        let exon_length = exon.end - exon.start + 1;
        if (transcript.cds && pos_in_transcript < transcript.cds.start && pos_in_transcript + exon_length >= transcript.cds.start) {
            // CDS starts in this exon
            const utr5_len = transcript.cds.start - pos_in_transcript - 1;
            if (utr5_len > 0) {
                blocks.push({
                    kind: blockType + extra,
                    seq: geneSeq.seq.substring(offset + pos_in_gene, offset + pos_in_gene + utr5_len)
                });
                exon_length -= utr5_len;
                pos_in_gene += utr5_len;
                pos_in_transcript = transcript.cds.start - 1;
            }
            blockType = "cds";
        }
        if (blockType === "cds" && pos_in_transcript + exon_length >= transcript.cds.end) {
            // CDS ends in this exon
            const cds_len = transcript.cds.end - pos_in_transcript;
            if (cds_len > 0) {
                blocks.push({
                    kind: blockType + extra,
                    seq: geneSeq.seq.substring(offset + pos_in_gene, offset + pos_in_gene + cds_len)
                });
                exon_length -= cds_len;
                pos_in_gene += cds_len;
                pos_in_transcript = transcript.cds.end;
            }
            blockType = "utr3";
        }
        if (exon_length > 0) blocks.push({
            kind: blockType + extra,
            seq: geneSeq.seq.substring(offset + pos_in_gene, offset + pos_in_gene + exon_length)
        });
        pos_in_gene = exon.end;
        pos_in_transcript += exon_length;
    });
    // check if there's more to the gene locus after end of transcript?
    // downstream is currently relative to end of transcript but upstream is relative to first TSS
    if (down > 0) blocks.push({
        kind: "downstream",
        seq: geneSeq.seq.substring(offset + pos_in_gene, offset + pos_in_gene + down).toLowerCase()
    });
    return blocks;
};
const $527ebc19dc92444d$var$buildId = (gene, geneSeq, up, down)=>{
    let gs = gene.location.strand === 1 ? gene.location.start - up : gene.location.start - down;
    let ge = gene.location.strand === 1 ? gene.location.end + down : gene.location.end + up;
    let extras = [];
    if (gene.location.strand === -1) extras.push("reverse");
    if (up > 0) extras.push(`upstream=${up}`);
    if (down > 0) extras.push(`downstream=${down}`);
    return `${geneSeq.genome}|${gene._id}|${gene.location.region}:${gs}..${ge} ${extras.join("|")}`;
};
const $527ebc19dc92444d$var$Detail = (props)=>{
    const gene = props.geneDocs[props.searchResult.id];
    const [tab, setTab] = (0, $gXNCa$react.useState)("dna");
    const [upstream, setUpstream] = (0, $gXNCa$react.useState)(0);
    const [downstream, setDownstream] = (0, $gXNCa$react.useState)(0);
    const [tid, setTid] = (0, $gXNCa$react.useState)(gene.gene_structure.canonical_transcript);
    let geneSeq;
    let rnaSeq;
    let pepSeq;
    if (props.geneSequences && props.geneSequences[gene._id]) geneSeq = props.geneSequences[gene._id];
    else {
        props.doRequestGeneSequence(gene);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("pre", {
            children: "loading"
        });
    }
    if (props.rnaSequences && props.rnaSequences[tid]) rnaSeq = props.rnaSequences[tid];
    else {
        props.doRequestRnaSequence(tid, gene);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("pre", {
            children: "loading"
        });
    }
    const maxUp = gene.location.strand === 1 ? gene.location.start - geneSeq.start : geneSeq.end - gene.location.end;
    const maxDown = gene.location.strand === -1 ? gene.location.start - geneSeq.start : geneSeq.end - gene.location.end;
    const transcript = gene.gene_structure.transcripts.find((tr)=>tr.id === tid);
    let tl_id;
    if (transcript.translation) {
        tl_id = transcript.translation.id;
        if (props.pepSequences && props.pepSequences[tl_id]) pepSeq = props.pepSequences[tl_id];
        else {
            props.doRequestPepSequence(tl_id, gene);
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("pre", {
                children: "loading"
            });
        }
    }
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Tabs), {
        activeKey: tab,
        onSelect: (k)=>setTab(k),
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Tab), {
                tabClassName: "dna",
                eventKey: "dna",
                title: "Genomic sequence",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Container), {
                        style: {
                            width: "100ch",
                            marginLeft: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Row), {
                                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Col), {
                                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
                                            children: "Show flanking sequence"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Row), {
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Col), {
                                        style: {
                                            maxWidth: "5ch",
                                            textAlign: "right"
                                        },
                                        children: upstream
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Col), {
                                        style: {
                                            maxWidth: "20ch"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Form).Range, {
                                                className: "reverse-slide",
                                                value: upstream,
                                                onChange: (e)=>setUpstream(e.target.value),
                                                min: 0,
                                                max: maxUp,
                                                step: 10
                                            }),
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                                style: {
                                                    textAlign: "right"
                                                },
                                                children: "Upstream"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Col), {
                                        style: {
                                            maxWidth: "30ch"
                                        },
                                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                            className: "styled-span",
                                            children: [
                                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                                    className: "vertical-line"
                                                }),
                                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                                    className: "horizontal-line"
                                                }),
                                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                                    children: "Transcript (unspliced)"
                                                }),
                                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                                    className: "horizontal-line"
                                                }),
                                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                                    className: "vertical-line"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Col), {
                                        style: {
                                            maxWidth: "20ch"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Form).Range, {
                                                value: downstream,
                                                onChange: (e)=>setDownstream(e.target.value),
                                                min: 0,
                                                max: maxDown,
                                                step: 10
                                            }),
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                                style: {
                                                    textAlign: "left"
                                                },
                                                children: "Downstream"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Col), {
                                        style: {
                                            maxWidth: "5ch",
                                            textAlign: "left"
                                        },
                                        children: downstream
                                    })
                                ]
                            }),
                            gene.gene_structure.transcripts.length > 1 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Row), {
                                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Col), {
                                    children: [
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
                                                children: "Highlight transcript"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.ButtonGroup), {
                                            children: gene.gene_structure.transcripts.sort((a, b)=>a.id.localeCompare(b.id)).map((tr, idx)=>{
                                                let v = tr.id === gene.gene_structure.canonical_transcript ? "primary" : "secondary";
                                                if (tr.id !== tid) v = `outline-${v}`;
                                                return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.ToggleButton), {
                                                    variant: v,
                                                    id: `radio-${idx}`,
                                                    type: "radio",
                                                    name: tr.id,
                                                    value: tr.id,
                                                    checked: tr.id === tid,
                                                    onChange: (e)=>setTid(e.currentTarget.value),
                                                    children: tr.id
                                                }, idx);
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    geneSeq && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($527ebc19dc92444d$var$CodeBlock, {
                        id: $527ebc19dc92444d$var$buildId(gene, geneSeq, +upstream, +downstream),
                        seq: geneSeq.seq.substring(maxUp - +upstream, maxUp + gene.location.end - gene.location.start + 1 + +downstream),
                        blocks: $527ebc19dc92444d$var$decorateSeq(geneSeq, gene, +upstream, +downstream, tid, "dna")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Tab), {
                tabClassName: "rna",
                eventKey: "rna",
                title: "Transcript sequence",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Container), {
                        style: {
                            width: "100ch",
                            marginLeft: 0
                        },
                        children: gene.gene_structure.transcripts.length > 1 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Row), {
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Col), {
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
                                            children: "Select transcript"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.ButtonGroup), {
                                        children: gene.gene_structure.transcripts.sort((a, b)=>a.id.localeCompare(b.id)).map((tr, idx)=>{
                                            let v = tr.id === gene.gene_structure.canonical_transcript ? "primary" : "secondary";
                                            if (tr.id !== tid) v = `outline-${v}`;
                                            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.ToggleButton), {
                                                variant: v,
                                                id: `radio-${idx}`,
                                                type: "radio",
                                                name: tr.id,
                                                value: tr.id,
                                                checked: tr.id === tid,
                                                onChange: (e)=>setTid(e.currentTarget.value),
                                                children: tr.id
                                            }, idx);
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    geneSeq && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($527ebc19dc92444d$var$CodeBlock, {
                        id: tid,
                        seq: rnaSeq.seq,
                        blocks: $527ebc19dc92444d$var$decorateSeq(geneSeq, gene, 0, 0, tid, "rna")
                    })
                ]
            }),
            gene.biotype === "protein_coding" && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Tab), {
                tabClassName: "pep",
                eventKey: "pep",
                title: "Peptide sequence",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Container), {
                        style: {
                            width: "100ch",
                            marginLeft: 0
                        },
                        children: gene.gene_structure.transcripts.length > 1 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Row), {
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Col), {
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
                                            children: "Select transcript"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.ButtonGroup), {
                                        children: gene.gene_structure.transcripts.sort((a, b)=>a.id.localeCompare(b.id)).map((tr, idx)=>{
                                            let v = tr.id === gene.gene_structure.canonical_transcript ? "primary" : "secondary";
                                            if (tr.id !== tid) v = `outline-${v}`;
                                            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.ToggleButton), {
                                                variant: v,
                                                id: `radio-${idx}`,
                                                type: "radio",
                                                name: tr.id,
                                                value: tr.id,
                                                checked: tr.id === tid,
                                                onChange: (e)=>setTid(e.currentTarget.value),
                                                children: tr.id
                                            }, idx);
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    geneSeq && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($527ebc19dc92444d$var$CodeBlock, {
                        id: tl_id,
                        seq: pepSeq.seq,
                        blocks: $527ebc19dc92444d$var$decoratePeptide(pepSeq.seq, transcript)
                    })
                ]
            })
        ]
    });
};
var $527ebc19dc92444d$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)("selectConfiguration", "selectGeneSequences", "selectRnaSequences", "selectPepSequences", "doRequestGeneSequence", "doRequestRnaSequence", "doRequestPepSequence", $527ebc19dc92444d$var$Detail);





let $6c5c4f90059875bf$var$external = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("small", {
    title: "This link opens a page from an external site",
    children: [
        " ",
        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
            className: "fa fa-external-link"
        })
    ]
});
let $6c5c4f90059875bf$var$inventory = {
    sequences: (0, $527ebc19dc92444d$export$2e2bcd8739ae039),
    location: (0, $264d7db426cab787$export$2e2bcd8739ae039),
    expression: (0, $9e29a4f60318db7a$export$2e2bcd8739ae039),
    homology: (0, $64fad37f770d2bfe$export$2e2bcd8739ae039),
    pathways: (0, $54c74a4689d5a778$export$2e2bcd8739ae039),
    VEP: (0, $283508ffcf8a47c4$export$2e2bcd8739ae039),
    xrefs: (0, $b7cae39a716ca5a8$export$2e2bcd8739ae039),
    pubs: (0, $830f925242a0b007$export$2e2bcd8739ae039)
};
function $6c5c4f90059875bf$var$renderTairSummary(searchResult) {
    const summary = searchResult.summary;
    if (summary && summary !== "NULL" && searchResult.system_name === "arabidopsis_thaliana") return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "gene-summary-tair",
        children: $6c5c4f90059875bf$var$trimSummary(summary)
    });
}
function $6c5c4f90059875bf$var$trimSummary(summary) {
    if (summary.length > 160) {
        const start = summary.substr(0, 150);
        const rest = summary.substr(150);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("p", {
            children: [
                start,
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "ellipsis",
                    children: "\u2026"
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "rest",
                    children: rest
                })
            ]
        });
    } else return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("p", {
        children: summary
    });
}
const $6c5c4f90059875bf$var$PanLink = (props)=>{
    const gene = props.gene;
    const pan = props.pan;
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "gene-panlink",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("a", {
            target: "_blank",
            href: pan.url + gene.id,
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("img", {
                src: pan.svg,
                title: `View this gene at ${pan.name}`
            })
        })
    });
};
const $6c5c4f90059875bf$var$CurationComponent1 = ({ curation: curation })=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "gene-curation",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                children: "Curated gene structure"
            }),
            curation.okay > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                className: "status",
                children: [
                    "\u2714\uFE0F ",
                    curation.okay
                ]
            }),
            curation.flagged > -10 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                className: "status",
                children: [
                    "\u26A0\uFE0F ",
                    curation.flagged
                ]
            })
        ]
    });
};
const $6c5c4f90059875bf$var$CurationComponent = ({ curation: curation, gene: gene })=>{
    const total = curation.okay + curation.flagged;
    const okayRatio = curation.okay / total;
    const flaggedRatio = curation.flagged / total;
    const tooltip = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Tooltip), {
        id: "tooltip",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("strong", {
                children: "Gene structure"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
            "Okay: ",
            curation.okay,
            " \xa0 Flagged: ",
            curation.flagged
        ]
    });
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.OverlayTrigger), {
        placement: "left",
        overlay: tooltip,
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("a", {
            className: "gene-curation",
            target: "_blank",
            href: `https://devdata.gramene.org/curation/curations?idList=${gene.id}`,
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "okay",
                    style: {
                        opacity: okayRatio
                    },
                    children: "\u2611"
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "flagged",
                    style: {
                        opacity: flaggedRatio
                    },
                    children: "\u26A0"
                })
            ]
        })
    });
};
const $6c5c4f90059875bf$var$ClosestOrthologCmp = (props)=>{
    let id, taxon_id, name, desc, species, className, identity;
    const gene = props.gene;
    if (gene.closest_rep_id) {
        name = gene.closest_rep_name || gene.closest_rep_id;
        desc = gene.closest_rep_description;
        species = gene.closest_rep_species_name;
        id = gene.closest_rep_id;
        taxon_id = gene.closest_rep_taxon_id;
        className = "closest-ortholog";
        identity = gene.closest_rep_identity || 0;
    } else if (gene.model_rep_id) {
        name = gene.model_rep_name || gene.model_rep_id;
        desc = gene.model_rep_description;
        species = gene.model_rep_species_name;
        id = gene.model_rep_id;
        taxon_id = gene.model_rep_taxon_id;
        className = "model-ortholog";
        identity = gene.model_rep_identity || 0;
    }
    var isZm = new RegExp(/^Zm00001e/);
    if (isZm.test(desc)) desc = "";
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: className,
        onClick: ()=>{
            props.doEnsureGrameneGenome(taxon_id);
            props.doReplaceGrameneFilters((0, $047461923b1badda$export$964d88edb00bbcaa)({
                category: "Gene",
                fq_field: "id",
                fq_value: id,
                name: name
            }));
        },
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "gene-species",
                children: species
            }),
            identity > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "rep-identity",
                children: Math.round(identity * 100)
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h3", {
                className: "gene-id",
                children: name
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("p", {
                children: desc
            })
        ]
    });
};
const $6c5c4f90059875bf$var$ClosestOrtholog = (0, $gXNCa$reduxbundlerreact.connect)("doReplaceGrameneFilters", "doEnsureGrameneGenome", $6c5c4f90059875bf$var$ClosestOrthologCmp);
function $6c5c4f90059875bf$var$renderClosestOrtholog(gene) {
    if ($6c5c4f90059875bf$var$shouldShowClosestOrtholog(gene)) // we used to not add the closest ortholog to the DOM if the homology detail was visible.
    // however, that could cause the height of the result to change. Instead we set visibility:hidden
    // so that the renderer takes into account the height of the ortholog even if not shown.
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($6c5c4f90059875bf$var$ClosestOrtholog, {
        gene: gene
    });
}
// show closest ortholog prominently if we have data to show:-
//   a. either there's a closest ortholog (determined by traversing the gene tree until an id or description looks
// curated) b. or there's a model ortholog (traverse tree to find an ortholog in arabidopsis)
function $6c5c4f90059875bf$var$shouldShowClosestOrtholog(searchResult) {
    return searchResult.closest_rep_id || searchResult.model_rep_id && searchResult.model_rep_id !== searchResult.id;
}
const $6c5c4f90059875bf$var$allDetails = [
    {
        id: "VEP",
        label: "Germplasm",
        popup: "Germplasm with protein truncating variants (PTVs)",
        available: false
    },
    {
        id: "sequences",
        label: "Sequences",
        popup: "Gene/cDNA/protein fasta",
        available: true
    },
    {
        id: "location",
        label: "Location",
        popup: "Genome Browser",
        available: false
    },
    {
        id: "expression",
        label: "Expression",
        popup: "Gene Expression Atlas",
        available: false
    },
    {
        id: "homology",
        label: "Homology",
        popup: "Gene Family Tree",
        available: false
    },
    {
        id: "pathways",
        label: "Pathways",
        popup: "Plant Reactome Pathways",
        available: false
    },
    {
        id: "pubs",
        label: "Papers",
        popup: "Curated Publications",
        available: false
    },
    {
        id: "xrefs",
        label: "Xrefs",
        popup: "Database Cross-references",
        available: false
    }
];
class $6c5c4f90059875bf$var$Gene extends (0, ($parcel$interopDefault($gXNCa$react))).Component {
    constructor(props){
        super(props);
        this.state = {
            details: $6c5c4f90059875bf$var$allDetails.map((o)=>({
                    ...o
                })).filter((d)=>props.config.details[d.id]),
            expandedDetail: props.expandedDetail
        };
        let hasData = {};
        props.searchResult.capabilities.forEach((c)=>{
            hasData[c] = true;
            if (c === "PanOryza") hasData.xrefs = true;
        });
        this.state.details.forEach((d)=>d.available |= hasData.hasOwnProperty(d.id));
    }
    getDetailStatus(d) {
        if (this.state.expandedDetail === d.id) return "expanded";
        if (d.available) return "closed";
        return d.id === "pubs" ? "empty" : "disabled";
    }
    setExpanded(d) {
        if (d.available || d.id === "pubs") {
            if (this.state.expandedDetail === d.id) this.setState({
                expandedDetail: null
            });
            else {
                const geneId = this.props.searchResult.id;
                if (!(this.props.geneDocs && this.props.geneDocs.hasOwnProperty(geneId))) this.props.requestGene(geneId);
                (0, ($parcel$interopDefault($gXNCa$reactga4))).event({
                    category: "Search",
                    action: "Details",
                    label: d.label
                });
                this.setState({
                    expandedDetail: d.id
                });
            }
        }
    }
    ensureGene(id) {
        if (!(this.props.geneDocs && this.props.geneDocs.hasOwnProperty(id))) {
            this.props.requestGene(id);
            return false;
        }
        return this.props.geneDocs[id].hasOwnProperty("taxon_id");
    }
    renderMetadata() {
        let gene = this.props.searchResult;
        if (gene.model_rep_taxon_id) gene.model_rep_species_name = this.props.taxLut[gene.model_rep_taxon_id].short_name;
        if (gene.closest_rep_taxon_id) gene.closest_rep_species_name = this.props.taxLut[gene.closest_rep_taxon_id].short_name;
        return $6c5c4f90059875bf$var$renderTairSummary(gene) || $6c5c4f90059875bf$var$renderClosestOrtholog(gene);
    }
    render() {
        const panSite = this.props.config.panSite;
        const searchResult = this.props.searchResult;
        const taxName = this.props.taxName;
        const curation = this.props.curation;
        // let orthologs='';
        // if (this.props.orthologs && this.props.orthologs.hasOwnProperty(searchResult.id)) {
        //   orthologs = this.props.orthologs[searchResult.id].join(', ');
        // }
        const numWordsInDescription = searchResult.description.split(" ").length;
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            className: "result-gene",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    className: "result-gene-summary",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                            className: "result-gene-title-body",
                            children: [
                                panSite.hasOwnProperty(searchResult.system_name) && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($6c5c4f90059875bf$var$PanLink, {
                                    pan: panSite[searchResult.system_name],
                                    gene: searchResult
                                }),
                                curation && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($6c5c4f90059875bf$var$CurationComponent, {
                                    curation: curation,
                                    gene: searchResult
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                    className: "gene-title",
                                    children: [
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                            className: "gene-species",
                                            children: taxName
                                        }),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("h3", {
                                            className: "gene-name",
                                            children: [
                                                searchResult.name,
                                                searchResult.id !== searchResult.name && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("small", {
                                                    className: "gene-id",
                                                    children: [
                                                        "\xa0",
                                                        searchResult.id
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                searchResult.synonyms && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("small", {
                                    className: "gene-synonyms",
                                    children: searchResult.synonyms.join(", ")
                                }),
                                (numWordsInDescription > 1 || searchResult.can_show.pubs) && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("p", {
                                    className: "gene-description",
                                    children: searchResult.description
                                })
                            ]
                        }),
                        this.renderMetadata()
                    ]
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                    className: "gene-detail-tabs",
                    children: this.state.details.map((d, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.OverlayTrigger), {
                            placement: "bottom",
                            overlay: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Tooltip), {
                                id: `tooltip`,
                                children: d.popup
                            }),
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                className: `col-md-1 text-center gene-detail-tab-${this.getDetailStatus(d)}`,
                                onClick: ()=>this.setExpanded(d),
                                children: d.label
                            }, idx)
                        }, idx))
                }),
                this.state.expandedDetail && this.ensureGene(searchResult.id) && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                    className: "visible-detail",
                    children: /*#__PURE__*/ (0, ($parcel$interopDefault($gXNCa$react))).createElement($6c5c4f90059875bf$var$inventory[this.state.expandedDetail], this.props)
                })
            ]
        });
    }
}
const $6c5c4f90059875bf$var$GeneList = (props)=>{
    if (props.grameneSearch && props.grameneSearch.response && props.grameneTaxonomy) {
        let prev, page, next;
        const numFound = props.grameneSearch.response.numFound;
        if (numFound > props.grameneSearchRows) {
            const pageNum = props.grameneSearchOffset / props.grameneSearchRows;
            page = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                style: {
                    padding: "10px"
                },
                children: [
                    "page ",
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                        children: pageNum + 1
                    }),
                    " of ",
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                        children: Math.ceil(numFound / props.grameneSearchRows)
                    })
                ]
            });
            prev = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reacticonsgr.GrHpe), {});
            if (pageNum > 0) prev = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Badge), {
                onClick: ()=>props.doRequestResultsPage(pageNum - 1),
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reacticonsgr.GrFormPrevious), {})
            });
            next = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reacticonsgr.GrHpe), {});
            if (numFound > props.grameneSearchOffset + props.grameneSearchRows) next = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Badge), {
                onClick: ()=>props.doRequestResultsPage(pageNum + 1),
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reacticonsgr.GrFormNext), {})
            });
        }
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    children: [
                        prev,
                        page,
                        next
                    ]
                }),
                props.grameneSearch.response.docs.map((g, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($6c5c4f90059875bf$var$Gene, {
                        searchResult: g,
                        config: props.configuration,
                        taxName: props.grameneTaxonomy[g.taxon_id].name,
                        geneDocs: props.grameneGenes,
                        requestGene: props.doRequestGrameneGene,
                        requestOrthologs: props.doRequestOrthologs,
                        orthologs: props.grameneOrthologs,
                        taxLut: props.grameneTaxonomy,
                        curation: props.curatedGenes ? props.curatedGenes[g.id] : null,
                        expandedDetail: props.grameneSearch.response.numFound === 1 && g.can_show.homology ? "homology" : null
                    }, idx)),
                prev,
                page,
                next
            ]
        });
    }
    return null;
};
var $6c5c4f90059875bf$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)("selectConfiguration", "selectGrameneSearch", "selectGrameneTaxonomy", "selectGrameneGenes", "selectGrameneOrthologs", "selectGrameneSearchOffset", "selectGrameneSearchRows", "selectCuratedGenes", "doRequestGrameneGene", "doRequestOrthologs", "doRequestResultsPage", $6c5c4f90059875bf$var$GeneList);












function $e2d7530b31b5433c$var$selectionStats(selections, taxonomy) {
    const selectionData = $e2d7530b31b5433c$var$getSelectionData(selections, taxonomy);
    const totalGeneResults = taxonomy.model.results.count;
    const fq = $e2d7530b31b5433c$var$fqFromSelections(selections);
    return {
        selectedGenes: selectionData.resultsCount,
        totalGeneResults: totalGeneResults,
        fq: fq,
        numSelectedBins: selectionData.binsCount,
        proportionGenesSelected: selectionData.resultsCount / totalGeneResults
    };
}
function $e2d7530b31b5433c$var$getSelectionData(selection, taxonomy) {
    return (0, ($parcel$interopDefault($gXNCa$lodash))).reduce(selection, (countAcc, sel)=>{
        const bins = taxonomy.getBins(sel.binFrom.idx, sel.binTo.idx);
        countAcc.binsCount += bins.length;
        countAcc.resultsCount += (0, ($parcel$interopDefault($gXNCa$lodash))).reduce(bins, (acc, bin)=>acc + bin.results.count, 0);
        return countAcc;
    }, {
        resultsCount: 0,
        binsCount: 0
    });
}
const $e2d7530b31b5433c$var$selectionToSolrRange = (sel)=>`[${sel.binFrom.idx} TO ${sel.binTo.idx}]`;
function $e2d7530b31b5433c$var$fqFromSelections(selections) {
    const rangeStrings = selections.map($e2d7530b31b5433c$var$selectionToSolrRange);
    return `fixed_1000__bin:(${rangeStrings.join(" ")})`;
}
const $e2d7530b31b5433c$var$Selections = ({ selections: selections, taxonomy: taxonomy, doAcceptGrameneSuggestion: doAcceptGrameneSuggestion, onFilter: onFilter })=>{
    const stats = $e2d7530b31b5433c$var$selectionStats(selections, taxonomy);
    const setFilter = ()=>{
        doAcceptGrameneSuggestion({
            category: "Selections",
            fq_field: "fixed_1000__bin",
            fq_value: `(${selections.map($e2d7530b31b5433c$var$selectionToSolrRange).join(" ")})`,
            name: `${selections.length} region${selections.length === 1 ? "" : "s"}`
        });
        onFilter();
    };
    const formatProportion = (prop)=>"(" + ((0, ($parcel$interopDefault($gXNCa$lodash))).isFinite(prop) ? (0, ($parcel$interopDefault($gXNCa$numeral)))(prop).format("0.0%") : undefined) + ")";
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Table), {
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("tbody", {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("th", {
                            children: "Number of selected genes"
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("td", {
                            children: [
                                stats.selectedGenes,
                                " ",
                                formatProportion(stats.proportionGenesSelected)
                            ]
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Button), {
                                size: "sm",
                                onClick: setFilter,
                                children: [
                                    "selections\xa0|",
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Badge), {
                                        children: stats.selectedGenes
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
var $e2d7530b31b5433c$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)("doAcceptGrameneSuggestion", $e2d7530b31b5433c$var$Selections);



class $a67cad486021eb32$var$TaxDist extends (0, ($parcel$interopDefault($gXNCa$react))).Component {
    constructor(props){
        super(props);
        this.state = {
            collapseEmpties: true
        };
    }
    handleSelection(selections) {
        this.setState({
            selections: selections
        });
    }
    handleHighlight(highlight) {
        this.setState({
            highlight: highlight
        });
    }
    handleFilter() {
        this.setState({
            selections: null
        });
    }
    toggleEmpties() {
        this.setState({
            collapseEmpties: !this.state.collapseEmpties
        });
    }
    render() {
        let selectedTaxa = {};
        if (this.props.grameneSearch && this.state.collapseEmpties) this.props.grameneSearch.facet_counts.facet_fields.taxon_id.filter((tid, idx)=>idx % 2 === 0).forEach((tid)=>{
            selectedTaxa[tid] = true;
        });
        else selectedTaxa = this.props.grameneGenomes.active;
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            className: "results-vis big-vis",
            children: [
                this.props.grameneTaxDist && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("button", {
                    type: "button",
                    className: "btn btn-primary btn-sm",
                    onClick: this.toggleEmpties.bind(this),
                    children: [
                        this.state.collapseEmpties ? "Expand" : "Collapse",
                        " empty branches"
                    ]
                }),
                this.props.grameneTaxDist && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, ($parcel$interopDefault($gXNCa$gramenesearchvis))), {
                    taxonomy: this.props.grameneTaxDist,
                    selectedTaxa: selectedTaxa,
                    onSelection: this.handleSelection.bind(this),
                    onHighlight: this.handleHighlight.bind(this)
                }),
                this.renderSelection()
            ]
        });
    }
    renderSelection() {
        if (this.state.selections && this.props.grameneTaxDist) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $e2d7530b31b5433c$export$2e2bcd8739ae039), {
            taxonomy: this.props.grameneTaxDist,
            selectedTaxa: {},
            selections: this.state.selections,
            onFilter: this.handleFilter.bind(this)
        });
    }
}
var $a67cad486021eb32$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)("selectGrameneTaxDist", "selectGrameneGenomes", "selectGrameneSearch", $a67cad486021eb32$var$TaxDist);







const $b36244140732570a$var$examples = [
    {
        subsite: {
            maize: 1,
            sorghum: 1,
            main: 1
        },
        text: "What are the orthologs of Arabidopsis thaliana's PAD4 gene in Andropogoneae?",
        filters: {
            status: "init",
            rows: 20,
            operation: "AND",
            negate: false,
            leftIdx: 0,
            rightIdx: 5,
            children: [
                {
                    fq_field: "homology__all_orthologs",
                    fq_value: "AT3G52430",
                    name: "Orthologs of PAD4",
                    category: "Gene Tree",
                    leftIdx: 1,
                    rightIdx: 2,
                    negate: false,
                    marked: false
                },
                {
                    fq_field: "taxonomy__ancestors",
                    fq_value: 147429,
                    name: "Andropogoneae",
                    category: "Taxonomy",
                    leftIdx: 3,
                    rightIdx: 4,
                    negate: false,
                    marked: false
                }
            ]
        }
    },
    {
        subsite: {
            grapevine: 1
        },
        text: "What are the orthologs of Arabidopsis thaliana's PAD4 gene in rosids?",
        filters: {
            status: "init",
            rows: 20,
            operation: "AND",
            negate: false,
            leftIdx: 0,
            rightIdx: 5,
            children: [
                {
                    fq_field: "homology__all_orthologs",
                    fq_value: "AT3G52430",
                    name: "Orthologs of PAD4",
                    category: "Gene Tree",
                    leftIdx: 1,
                    rightIdx: 2,
                    negate: false,
                    marked: false
                },
                {
                    fq_field: "taxonomy__ancestors",
                    fq_value: 71275,
                    name: "rosids",
                    category: "Taxonomy",
                    leftIdx: 3,
                    rightIdx: 4,
                    negate: false,
                    marked: false
                }
            ]
        }
    }
];
const $b36244140732570a$var$HelpDemo = ({ configuration: configuration, doReplaceGrameneFilters: doReplaceGrameneFilters })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Container), {
        fluid: true,
        style: {
            padding: "40px"
        },
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Row), {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h3", {
                    children: "Search Features"
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Row), {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.CardGroup), {
                    style: {
                        width: "80%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Card), {
                            style: {
                                "backgroundColor": "#f3f6f5",
                                "borderColor": "#DDE5E3"
                            },
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Card).Body, {
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Card).Title, {
                                        children: "Suggestions"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Card).Text, {
                                        children: "Matching terms are provided as you type:"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                        className: "gene-search-pic-sugg"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Card), {
                            style: {
                                "backgroundColor": "#f3f6f5",
                                "borderColor": "#DDE5E3"
                            },
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Card).Body, {
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Card).Title, {
                                        children: "Visualization"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Card).Text, {
                                        children: "See the distribution of results across all genomes:"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                        className: "gene-search-pic-results"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Card), {
                            style: {
                                "backgroundColor": "#f3f6f5",
                                "borderColor": "#DDE5E3"
                            },
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Card).Body, {
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Card).Title, {
                                        children: "Gene tree view"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Card).Text, {
                                        children: "Explore evolutionary history of a gene family:"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                        className: "gene-search-pic-genetree"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Row), {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h4", {
                    children: "For Example"
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Row), {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("small", {
                    children: [
                        "You can ask sophisticated questions about the genes:",
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("ul", {
                            children: $b36244140732570a$var$examples.filter((e)=>!!e.subsite[configuration.id]).map((e, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("a", {
                                        onClick: ()=>doReplaceGrameneFilters(e.filters),
                                        children: e.text
                                    })
                                }, idx))
                        })
                    ]
                })
            })
        ]
    });
var $b36244140732570a$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)("selectConfiguration", "doReplaceGrameneFilters", $b36244140732570a$var$HelpDemo);





class $67bf5a43401bffdc$var$GeneAttribs extends (0, ($parcel$interopDefault($gXNCa$react))).Component {
    constructor(props){
        super(props);
        this.state = {};
    }
    render() {
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
            className: "gramene-attribs",
            children: this.props.grameneGeneAttribs && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("pre", {
                children: "hi"
            })
        });
    }
}
var $67bf5a43401bffdc$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)("selectGrameneGeneAttribs", $67bf5a43401bffdc$var$GeneAttribs);






class $76e15aea9236bd47$var$TaxonomyModal extends (0, ($parcel$interopDefault($gXNCa$react))).Component {
    constructor(props){
        super(props);
        this.state = {
            genomes: Object.values(props.grameneMaps).sort((a, b)=>a.left_index - b.left_index)
        };
        if (Object.keys(props.grameneGenomes.active).length === 0) this.state.genomes.forEach((g)=>{
            g.selected = !g.hidden;
        });
        else this.state.genomes.forEach((g)=>{
            g.selected = !g.hidden && props.grameneGenomes.active[g.taxon_id];
        });
    }
    getSelectedGenomes() {
        let selected = {};
        let notHidden = {};
        let somethingWasSelected = false;
        this.state.genomes.forEach((g)=>{
            if (!g.hidden) {
                notHidden[g.taxon_id] = true;
                if (g.selected) {
                    selected[g.taxon_id] = true;
                    somethingWasSelected = true;
                }
            }
        });
        return somethingWasSelected ? selected : notHidden;
    }
    handleChange(e) {
        const idx = +e.target.value;
        let newState = Object.assign({}, this.state);
        newState.genomes[idx].selected = !newState.genomes[idx].selected;
        this.setState(newState);
    }
    handleClose() {
        this.props.doUpdateGrameneGenomes(this.getSelectedGenomes());
    }
    selectAll() {
        const genomes = this.state.genomes.map((g)=>{
            g.selected = true;
            return g;
        });
        this.setState({
            genomes: genomes
        });
    }
    selectNone() {
        const genomes = this.state.genomes.map((g)=>{
            g.selected = false;
            return g;
        });
        this.setState({
            genomes: genomes
        });
    }
    renderGenomes() {
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            children: [
                this.state.genomes.map((m, idx)=>{
                    if (m.hidden) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactjsxruntime.Fragment), {});
                    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                                checked: m.selected,
                                onChange: this.handleChange.bind(this),
                                type: "checkbox",
                                value: idx
                            }),
                            " ",
                            m.display_name
                        ]
                    }, idx);
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Button), {
                    onClick: this.handleClose.bind(this),
                    children: "Submit"
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Modal), {
            show: this.props.grameneGenomes.show,
            onHide: this.handleClose.bind(this),
            size: "lg",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Modal).Header, {
                    closeButton: true,
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Modal).Title, {
                        children: "Select Genomes of Interest"
                    })
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Modal).Body, {
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Button), {
                            variant: "outline-secondary",
                            onClick: this.selectAll.bind(this),
                            children: "All"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Button), {
                            variant: "outline-secondary",
                            onClick: this.selectNone.bind(this),
                            children: "None"
                        }),
                        this.renderGenomes()
                    ]
                })
            ]
        });
    }
}
var $76e15aea9236bd47$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)("selectGrameneGenomes", "selectGrameneMaps", "doUpdateGrameneGenomes", $76e15aea9236bd47$var$TaxonomyModal);








const $261baeb81c4d4d8a$var$LazyStudy = /*#__PURE__*/ (0, ($parcel$interopDefault($gXNCa$react))).lazy(()=>(parcelRequire("7u0Mi")));
const $261baeb81c4d4d8a$var$StudyList = (props)=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Accordion), {
        alwaysOpen: true,
        defaultActiveKey: props.studies.length === 1 ? "study_0" : undefined,
        children: props.studies.map((study, idx)=>{
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Accordion).Item, {
                eventKey: "study_" + idx,
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Accordion).Header, {
                        children: study.description
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Accordion).Body, {
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$react.Suspense), {
                            fallback: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                children: "Loading..."
                            }),
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($261baeb81c4d4d8a$var$LazyStudy, {
                                id: study._id
                            })
                        })
                    })
                ]
            }, idx);
        })
    });
};
const $261baeb81c4d4d8a$var$Expression = (props)=>{
    let searchTaxa = {};
    if (props.grameneSearch) {
        const taxon_id_facet = props.grameneSearch.facet_counts.facet_fields.taxon_id;
        taxon_id_facet.filter((tid, idx)=>idx % 2 === 0).forEach((tid)=>searchTaxa[tid] = true);
    }
    const availableTaxa = Object.keys(props.expressionStudies).filter((tid)=>searchTaxa[tid] || searchTaxa[tid + "001"]).sort((a, b)=>props.grameneMaps[a + "001"].left_index - props.grameneMaps[b + "001"].left_index);
    return availableTaxa && props.grameneTaxonomy && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                children: [
                    "This is where you can launch a component for the selected samples. props.desiredSamples lists them. This component can request the data from the API organize samples by factor metadata? One big table with all the studies?",
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Button), {
                        children: [
                            "Show Samples (",
                            Object.keys(props.desiredSamples).length,
                            " selected)"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Accordion), {
                alwaysOpen: true,
                defaultActiveKey: availableTaxa.length === 1 ? "tax_0" : undefined,
                children: availableTaxa.map((tid, idx)=>{
                    const n = props.expressionStudies[tid].length;
                    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Accordion).Item, {
                        eventKey: "tax_" + idx,
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Accordion).Header, {
                                children: [
                                    props.grameneTaxonomy[tid].name,
                                    " - ",
                                    n,
                                    " ",
                                    n === 1 ? "study" : "studies"
                                ]
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Accordion).Body, {
                                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($261baeb81c4d4d8a$var$StudyList, {
                                    studies: props.expressionStudies[tid]
                                })
                            })
                        ]
                    }, idx);
                })
            })
        ]
    });
};
var $261baeb81c4d4d8a$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)("selectConfiguration", "selectGrameneSearch", "selectGrameneTaxonomy", "selectGrameneMaps", "selectExpressionStudies", "selectDesiredSamples", $261baeb81c4d4d8a$var$Expression);








const $0f50f369018a42ef$var$auth = (0, $gXNCa$firebaseauth.getAuth)((0, $047461923b1badda$export$a4e2c8f07e884e));
const $0f50f369018a42ef$var$MAX_GENE_IDS = 1000; // Define the maximum number of gene IDs allowed
const $0f50f369018a42ef$var$GeneListDisplayComponent = (props)=>{
    const [savedGeneLists, setSavedGeneLists] = (0, $gXNCa$react.useState)([]);
    const [error, setError] = (0, $gXNCa$react.useState)(null);
    const [user, setUser] = (0, $gXNCa$react.useState)({});
    (0, $gXNCa$firebaseauth.onAuthStateChanged)($0f50f369018a42ef$var$auth, (user)=>setUser(user));
    // Fetch saved gene lists from a backend or local storage
    const fetchSavedGeneLists = async ()=>{
        try {
            // Replace this with actual fetch from your backend or storage
            const response = await fetch(`${props.api}/gene-lists`);
            const result = await response.json();
            if (response.ok) setSavedGeneLists(result.savedLists); // Assuming savedLists is an array of saved gene lists
            else setError("Error fetching gene lists.");
        } catch (err) {
            setError("Failed to fetch gene lists. Please try again later.");
        }
    };
    // Fetch data when the component is mounted
    (0, $gXNCa$react.useEffect)(()=>{
        fetchSavedGeneLists();
    }, []);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "gene-list-display-component",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h4", {
                children: "Saved Gene Lists"
            }),
            error && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Alert), {
                variant: "danger",
                children: error
            }),
            savedGeneLists.length > 0 ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Table), {
                striped: true,
                bordered: true,
                hover: true,
                className: "mt-4",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("th", {
                                    children: "List Name"
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("th", {
                                    children: "Number of Genes"
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("th", {
                                    children: "Actions"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("tbody", {
                        children: savedGeneLists.map((list, index)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                                        children: list.name
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                                        children: list.genes.length
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("td", {
                                        children: [
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Button), {
                                                variant: "info",
                                                onClick: ()=>$0f50f369018a42ef$var$viewGeneList(list),
                                                children: "View"
                                            }),
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Button), {
                                                variant: "danger",
                                                onClick: ()=>$0f50f369018a42ef$var$deleteGeneList(props.api, list.id),
                                                className: "ml-2",
                                                children: "Delete"
                                            })
                                        ]
                                    })
                                ]
                            }, index))
                    })
                ]
            }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Alert), {
                variant: "warning",
                className: "mt-4",
                children: "No saved gene lists found."
            })
        ]
    });
};
// Example functions for viewing and deleting lists
const $0f50f369018a42ef$var$viewGeneList = (list)=>{
    alert(`Viewing gene list: ${list.name}\nGenes: ${list.genes.join(", ")}`);
};
const $0f50f369018a42ef$var$deleteGeneList = async (api, listId)=>{
    if (window.confirm("Are you sure you want to delete this gene list?")) // Replace with the actual delete request
    try {
        await fetch(`${api}/gene-lists/${listId}`, {
            method: "DELETE"
        });
        alert("Gene list deleted!");
    // Optionally refetch the updated list
    } catch (err) {
        alert("Failed to delete gene list.");
    }
};
const $0f50f369018a42ef$var$GeneListComponent = (props)=>{
    const [geneList, setGeneList] = (0, $gXNCa$react.useState)("");
    const [listHash, setListHash] = (0, $gXNCa$react.useState)(null);
    const [validationError, setValidationError] = (0, $gXNCa$react.useState)([]);
    const [listName, setListName] = (0, $gXNCa$react.useState)("");
    const [listIsPublic, setListIsPublic] = (0, $gXNCa$react.useState)(false);
    const [validatedList, setValidatedList] = (0, $gXNCa$react.useState)([]);
    const [errorMessage, setErrorMessage] = (0, $gXNCa$react.useState)("");
    const [loading, setLoading] = (0, $gXNCa$react.useState)(false); // New loading state
    const [user, setUser] = (0, $gXNCa$react.useState)({});
    (0, $gXNCa$firebaseauth.onAuthStateChanged)($0f50f369018a42ef$var$auth, (user)=>setUser(user));
    // Function to handle gene list input
    const handleGeneListChange = (event)=>{
        setGeneList(event.target.value);
    };
    // Function to handle drag and drop of gene list
    const handleDrop = (event)=>{
        event.preventDefault();
        const geneData = event.dataTransfer.getData("text");
        setGeneList(geneData);
    };
    // Function to handle drag over (needed for drop)
    const handleDragOver = (event)=>{
        event.preventDefault();
    };
    // Function to submit gene list for validation
    const handleSubmit = async ()=>{
        const geneArray = geneList.split("\n").filter(Boolean); // Convert the gene list into an array and filter out empty values
        if (geneArray.length > $0f50f369018a42ef$var$MAX_GENE_IDS) {
            setErrorMessage(`You have exceeded the maximum limit of ${$0f50f369018a42ef$var$MAX_GENE_IDS} gene IDs.`);
            return;
        }
        setErrorMessage(""); // Reset error message if validation passes
        setLoading(true); // Set loading state to true to show progress
        try {
            const response = await fetch(`${props.api}/gene_lists/validate`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    ids: geneArray
                })
            });
            const result = await response.json();
            if (result.hash) {
                setListHash(result.hash);
                setValidatedList(result.ids);
                setValidationError(result.missing);
            } else // Handle errors from validation
            alert("Error during validation.");
        } catch (error) {
            alert("There was an error with the validation service.", error);
        } finally{
            setLoading(false); // Set loading to false when the request is complete
        }
    };
    // Function to save the validated gene list
    const handleSaveList = async ()=>{
        const queryParams = {
            label: listName,
            hash: listHash,
            site: props.site,
            isPublic: listIsPublic
        };
        const queryString = new URLSearchParams(queryParams).toString();
        const token = await user.getIdToken();
        try {
            const response = await fetch(`${props.api}/gene_list?${queryString}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });
            if (!response.ok) throw new Error("Failed to save list");
            const result = await response.json();
            console.log(result);
        } catch (error) {
            console.error("There was an problem with fetch", error);
        }
    };
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "gene-list-component",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h4", {
                children: "Gene List Validator"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Form), {
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Form).Group, {
                        controlId: "geneList",
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Form).Label, {
                                children: "Paste or drop your gene list here:"
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Form).Control, {
                                as: "textarea",
                                rows: 10,
                                value: geneList,
                                onChange: handleGeneListChange,
                                placeholder: `Paste or drop your gene list here (Maximum: ${$0f50f369018a42ef$var$MAX_GENE_IDS} IDs)`,
                                onDrop: handleDrop,
                                onDragOver: handleDragOver
                            })
                        ]
                    }),
                    errorMessage && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Alert), {
                        variant: "danger",
                        children: errorMessage
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Button), {
                        variant: "primary",
                        onClick: handleSubmit,
                        children: "Validate Gene List"
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "validation-summary mt-4",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h3", {
                        children: "Validation in Progress..."
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Spinner), {
                        animation: "border",
                        role: "status",
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                            className: "sr-only",
                            children: "Validating..."
                        })
                    })
                ]
            }),
            !loading && listHash && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "validation-summary mt-4",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h3", {
                        children: "Validation Summary"
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Alert), {
                        variant: "info",
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("p", {
                                children: [
                                    "hash: ",
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("code", {
                                        children: listHash
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("p", {
                                children: [
                                    "Items Validated: ",
                                    validatedList.length
                                ]
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("p", {
                                children: [
                                    "Items Not Validated: ",
                                    validationError.length
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("ul", {
                        children: validationError.map((errorItem, index)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("li", {
                                children: errorItem
                            }, index))
                    })
                ]
            }),
            !loading && validatedList.length > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "save-list mt-4",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Form).Group, {
                        controlId: "listName",
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Form).Label, {
                                children: "Save Validated Gene List"
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Form).Control, {
                                type: "text",
                                value: listName,
                                onChange: (e)=>setListName(e.target.value),
                                placeholder: "Enter list name"
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Form).Check, {
                                type: "switch",
                                id: "listIsPublic",
                                label: "Public",
                                onChange: (e)=>setListIsPublic(!listIsPublic)
                            })
                        ]
                    }),
                    user ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Button), {
                        variant: "success",
                        onClick: handleSaveList,
                        children: "Save Gene List"
                    }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Button), {
                        variant: "dark",
                        disabled: true,
                        children: "Login Required"
                    })
                ]
            })
        ]
    });
};
const $0f50f369018a42ef$var$UserGeneListsComponent = (props)=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Container), {
        fluid: true,
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Row), {
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Col), {
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($0f50f369018a42ef$var$GeneListComponent, {
                        api: props.configuration.grameneData,
                        site: props.configuration.id
                    })
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Col), {
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($0f50f369018a42ef$var$GeneListDisplayComponent, {
                        api: props.configuration.grameneData,
                        site: props.configuration.id
                    })
                })
            ]
        })
    });
};
var $0f50f369018a42ef$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)("selectConfiguration", $0f50f369018a42ef$var$UserGeneListsComponent);








const $c5d403787de8b05f$var$auth = (0, $gXNCa$firebaseauth.getAuth)((0, $047461923b1badda$export$a4e2c8f07e884e));
const $c5d403787de8b05f$var$provider = new (0, $gXNCa$firebaseauth.GoogleAuthProvider)();
const $c5d403787de8b05f$var$Auth = (props)=>{
    const [user, setUser] = (0, $gXNCa$react.useState)({});
    (0, $gXNCa$firebaseauth.onAuthStateChanged)($c5d403787de8b05f$var$auth, (user)=>setUser(user));
    function handleLogin() {
        (0, $gXNCa$firebaseauth.signInWithPopup)($c5d403787de8b05f$var$auth, $c5d403787de8b05f$var$provider).then((result)=>{
            setUser(result.user);
        }).catch((err)=>{
            console.log(err);
        });
    }
    function handleLogout() {
        (0, $gXNCa$firebaseauth.signOut)($c5d403787de8b05f$var$auth).then(()=>{
            setUser(null);
        }).catch((err)=>{
            console.log(err);
        });
    }
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: props.configuration.id === "sorghum" ? "sorghumbase-auth-container" : "gramene-auth-container",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                children: "Account"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                children: user ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Button), {
                    size: "sm",
                    variant: "success",
                    onClick: handleLogout,
                    children: user.displayName
                }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Button), {
                    size: "sm",
                    variant: "success",
                    onClick: handleLogin,
                    children: "Login"
                })
            })
        ]
    });
};
var $c5d403787de8b05f$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)("selectConfiguration", $c5d403787de8b05f$var$Auth);




const $693dd8c7a5607c3a$var$inventory = {
    help: (0, $b36244140732570a$export$2e2bcd8739ae039),
    list: (0, $6c5c4f90059875bf$export$2e2bcd8739ae039),
    taxonomy: (0, $a67cad486021eb32$export$2e2bcd8739ae039),
    attribs: (0, $67bf5a43401bffdc$export$2e2bcd8739ae039),
    expression: (0, $261baeb81c4d4d8a$export$2e2bcd8739ae039),
    userLists: (0, $0f50f369018a42ef$export$2e2bcd8739ae039)
};
const $693dd8c7a5607c3a$var$StatusCmp = (props)=>{
    let content = props.grameneFiltersStatus;
    // if (props.grameneFiltersStatus === 'init') {
    //   props.doClearGrameneFilters();
    // }
    if (props.grameneFiltersStatus === "ready") {
        let tally = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
            children: "Ready"
        });
        if (props.grameneSearch) {
            let genes = props.grameneSearch.response.numFound;
            let genomes = props.grameneSearch.facet_counts.facet_fields.taxon_id.length / 2;
            tally = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                        children: genes
                    }),
                    " genes in ",
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                        children: genomes
                    }),
                    " genomes"
                ]
            });
        }
        const popover = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Popover), {
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Popover).Header, {
                    as: "h3",
                    children: "Genomes Filter"
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Popover).Body, {
                    children: [
                        "Searching ",
                        props.activeGenomeCount,
                        " genomes"
                    ]
                })
            ]
        });
        content = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
            children: [
                tally,
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.OverlayTrigger), {
                    placement: "auto",
                    overlay: popover,
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        style: {
                            float: "right",
                            cursor: "pointer"
                        },
                        onClick: props.doShowGrameneGenomes,
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reacticonsbs.BsGearFill), {})
                    })
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $76e15aea9236bd47$export$2e2bcd8739ae039), {})
            ]
        });
    }
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        style: {
            padding: "5px",
            color: "cornsilk",
            fontSize: "small"
        },
        children: content
    });
};
const $693dd8c7a5607c3a$export$96e9906d6d93a972 = (0, $gXNCa$reduxbundlerreact.connect)("selectGrameneSearch", "selectGrameneFiltersStatus", "selectActiveGenomeCount", "doShowGrameneGenomes", "doClearGrameneFilters", $693dd8c7a5607c3a$var$StatusCmp);
const $693dd8c7a5607c3a$var$handleClick = (e, moveCopyMode, showMarked, node, actions)=>{
    if (!e) e = window.event;
    e.cancelBubble = true;
    if (e.stopPropagation) e.stopPropagation();
    if (showMarked && moveCopyMode) {
        if (node.marked) actions.selectTarget(node);
        else actions.unmarkTargets();
    }
    console.log(node, showMarked);
};
function $693dd8c7a5607c3a$var$logAction(action) {
    (0, ($parcel$interopDefault($gXNCa$reactga4))).event({
        category: "Search",
        action: action
    });
}
const $693dd8c7a5607c3a$var$Filter = ({ node: node, moveCopyMode: moveCopyMode, showMarked: showMarked, actions: actions })=>{
    let classes = "gramene-filter gramene-filter";
    if (node.operation) classes = `${classes}-${node.operation}`;
    if (node.negate) classes = `${classes} gramene-filter-NOT`;
    if (showMarked && node.marked) classes = `${classes} gramene-filter-marked`;
    let content = "";
    let menu = "";
    let children = [];
    if (node.showMenu) {
        let key = 1;
        let menuItems = [];
        if (node.hasOwnProperty("operation")) menuItems.push(/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("li", {
            onClick: ()=>{
                $693dd8c7a5607c3a$var$logAction(`Change to ${node.operation}`);
                actions.changeOperation(node);
            },
            children: [
                "convert to ",
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
                    children: node.operation === "AND" ? "OR" : "AND"
                })
            ]
        }, key++));
        if (node.leftIdx > 0) {
            menuItems.push(/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("li", {
                onClick: ()=>{
                    $693dd8c7a5607c3a$var$logAction(`Delete filter`);
                    actions.deleteNode(node);
                },
                children: "delete"
            }, key++));
            menuItems.push(/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("li", {
                onClick: ()=>{
                    $693dd8c7a5607c3a$var$logAction(`Move filter`);
                    actions.markTargets(node, "move");
                },
                children: [
                    "move",
                    node.isSource && " select destination"
                ]
            }, key++));
            menuItems.push(/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("li", {
                onClick: ()=>{
                    $693dd8c7a5607c3a$var$logAction(`Copy filter`);
                    actions.markTargets(node, "copy");
                },
                children: [
                    "copy",
                    node.isSource && " select destination"
                ]
            }, key++));
        }
        menuItems.push(/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("li", {
            onClick: ()=>{
                $693dd8c7a5607c3a$var$logAction(`Negate filter`);
                actions.negate(node);
            },
            children: "negate"
        }, key++));
        menu = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
            className: "gramene-filter-menu",
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("ul", {
                children: menuItems
            })
        });
    }
    let warning;
    if (node.warning) {
        const popover = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactbootstrap.Popover), {
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Popover).Header, {
                    as: "h3",
                    children: "Warning"
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.Popover).Body, {
                    children: node.warning
                })
            ]
        });
        warning = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbootstrap.OverlayTrigger), {
            placement: "auto",
            overlay: popover,
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                style: {
                    float: "right",
                    color: "red",
                    cursor: "pointer"
                },
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reacticonsio5.IoAlertCircle), {})
            })
        });
    }
    if (node.operation) {
        children = node.children.map((child, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($693dd8c7a5607c3a$var$Filter, {
                moveCopyMode: moveCopyMode,
                node: child,
                showMarked: showMarked,
                actions: actions
            }, idx));
        content = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "gramene-filter-operation",
                    onClick: ()=>actions.toggleMenu(node),
                    children: node.operation
                }),
                warning
            ]
        });
    } else content = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
        className: "gramene-filter-text",
        onClick: ()=>actions.toggleMenu(node),
        children: [
            node.category,
            " |\xa0",
            node.name
        ]
    });
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: classes,
        onClick: (e)=>$693dd8c7a5607c3a$var$handleClick(e, moveCopyMode, showMarked, node, actions),
        children: [
            content,
            menu,
            children
        ]
    }, node.leftIdx);
};
const $693dd8c7a5607c3a$var$FiltersCmp = (props)=>{
    const actions = {
        negate: props.doNegateGrameneFilter,
        deleteNode: props.doDeleteGrameneFilter,
        changeOperation: props.doChangeGrameneFilterOperation,
        selectTarget: props.doMoveOrCopyGrameneFilter,
        markTargets: props.doMarkGrameneFilterTargets,
        unmarkTargets: props.doUnmarkGrameneFilterTargets,
        toggleMenu: props.doToggleGrameneFilterMenu
    };
    if (props.grameneFilters.rightIdx > 1) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: props.configuration.id === "sorghum" ? "sorghumbase-filter-container" : "gramene-filter-container",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                children: "Filters"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                style: {
                    float: "right",
                    cursor: "pointer"
                },
                onClick: props.doClearGrameneFilters,
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reacticonsbs.BsTrash), {})
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($693dd8c7a5607c3a$var$Filter, {
                node: props.grameneFilters,
                moveCopyMode: props.grameneFilters.moveCopyMode,
                showMarked: props.grameneFilters.showMarked,
                actions: actions
            })
        ]
    });
    else return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: props.configuration.id === "sorghum" ? "sorghumbase-filter-container" : "gramene-filter-container",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                children: "Filters"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "gramene-filter gramene-filter-AND",
                children: "No filters defined"
            })
        ]
    });
};
const $693dd8c7a5607c3a$export$92a576f896a9bf72 = (0, $gXNCa$reduxbundlerreact.connect)("selectGrameneFilters", "selectConfiguration", "doNegateGrameneFilter", "doDeleteGrameneFilter", "doChangeGrameneFilterOperation", "doMoveOrCopyGrameneFilter", "doMarkGrameneFilterTargets", "doUnmarkGrameneFilterTargets", "doToggleGrameneFilterMenu", "doClearGrameneFilters", $693dd8c7a5607c3a$var$FiltersCmp);
const $693dd8c7a5607c3a$var$ResultsCmp = (props)=>{
    let activeViews = props.grameneViews.options;
    return props.grameneFilters.rightIdx > 0 ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        children: activeViews.map((v, idx)=>{
            let p = Object.assign({}, props);
            const divRef = (0, $gXNCa$react.useRef)(null);
            (0, $gXNCa$react.useEffect)(()=>{
                if (v.shouldScroll) {
                    const navBarHeight = 0;
                    const scrollPosition = divRef.current.offsetTop - navBarHeight;
                    window.scrollTo({
                        top: scrollPosition,
                        behavior: "smooth"
                    });
                    props.doCancelShouldScroll();
                }
            }, [
                v.shouldScroll
            ]);
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                ref: divRef,
                children: [
                    v.show === "on" && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        style: {
                            borderTopWidth: "medium"
                        },
                        className: "gramene-view-header",
                        children: v.name
                    }),
                    v.show === "on" && /*#__PURE__*/ (0, ($parcel$interopDefault($gXNCa$react))).createElement($693dd8c7a5607c3a$var$inventory[v.id], p)
                ]
            }, idx);
        })
    }) : null;
};
const $693dd8c7a5607c3a$export$4a34de49b46a2bfa = (0, $gXNCa$reduxbundlerreact.connect)("selectGrameneFilters", "selectGrameneViews", "doCancelShouldScroll", $693dd8c7a5607c3a$var$ResultsCmp);
const $693dd8c7a5607c3a$var$ViewsCmp = (props)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "gramene-view-container",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                children: "Views"
            }),
            props.grameneViews.options.filter((view)=>view.show !== "disabled").map((view, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    style: {
                        textWrap: "nowrap"
                    },
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, ($parcel$interopDefault($gXNCa$reactswitch))), {
                            onChange: ()=>props.doToggleGrameneView(view.id),
                            checked: view.show === "on",
                            height: 18,
                            width: 30,
                            handleDiameter: 16,
                            checkedIcon: false,
                            uncheckedIcon: false
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                            className: `gramene-view-span-${view.show}`,
                            onClick: (e)=>{
                                props.dontToggleGrameneView(view.id);
                            },
                            children: view.name
                        })
                    ]
                }, idx))
        ]
    });
const $693dd8c7a5607c3a$export$5cb791131c501f6a = (0, $gXNCa$reduxbundlerreact.connect)("selectGrameneViews", "doToggleGrameneView", "dontToggleGrameneView", $693dd8c7a5607c3a$var$ViewsCmp);




//# sourceMappingURL=index.js.map
